(() => {
  const isPackDrawerMode = window.location.search.includes('drawer=1');
  const shouldUsePackFullpageEditor = () => {
    const narrowViewport = window.matchMedia('(max-width: 749px)').matches;
    const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const noHover = window.matchMedia('(hover: none)').matches;
    const mobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');

    return narrowViewport || (coarsePointer && noHover) || mobileUserAgent;
  };
  const isPackDirectFullpageMode = isPackDrawerMode && window.parent === window;
  const isMobilePackFullpageMode = isPackDirectFullpageMode && shouldUsePackFullpageEditor();
  const PACK_RETURN_STORAGE_KEY = 'friziPackReturnUrl';

  const applyPackDrawerModeClass = () => {
    if (!isPackDrawerMode) return;

    document.documentElement.classList.add('frizi-pack-drawer-mode');
    if (document.body) document.body.classList.add('frizi-pack-drawer-mode');

    if (isMobilePackFullpageMode) {
      document.documentElement.classList.add('frizi-pack-mobile-fullpage-mode');
      if (document.body) document.body.classList.add('frizi-pack-mobile-fullpage-mode');
    }
  };

  applyPackDrawerModeClass();

  const initFriziProductPack = (sectionEl) => {
    applyPackDrawerModeClass();

    if (!sectionEl || sectionEl.dataset.friziProductPackInitialized === 'true') return;
    if (!sectionEl.querySelector('[data-purchase-mode]') || !sectionEl.querySelector('[data-bundle-builder]')) return;

    sectionEl.dataset.friziProductPackInitialized = 'true';
    const sectionId = sectionEl.id.replace(/^shopify-section-/, '');
    const DEBUG_PACK_EDITOR = false;
    const PACK_IMGBB_KEY = '08eb47717543b8278356f24eec9fbc93';
    const debugPackEditor = (...args) => {
      if (!DEBUG_PACK_EDITOR) return;
      console.log('[pack-editor]', ...args);
    };

    const upsellEl = sectionEl.querySelector('[data-frame-upsell]');
    const framesOnlyButtons = sectionEl.querySelectorAll('[data-frames-only-atc]');

    const purchaseTabs = sectionEl.querySelectorAll('[data-purchase-tab]');
    const purchasePanels = sectionEl.querySelectorAll('[data-purchase-panel]');
    const purchaseMode = sectionEl.querySelector('[data-purchase-mode]');
    const persistentPackContext = sectionEl.querySelector('[data-pack-prototype-context]');
    const persistentPackTitle = sectionEl.querySelector('[data-pack-prototype-title]');
    const persistentPackProgress = sectionEl.querySelector('[data-pack-prototype-progress]');
    const persistentPackThumbnails = sectionEl.querySelector('[data-pack-prototype-thumbnails]');
    const persistentPackAdd = sectionEl.querySelector('[data-pack-prototype-add]');
    const persistentPackFinalize = sectionEl.querySelector('[data-pack-prototype-finalize]');
    const persistentPackContinue = sectionEl.querySelector('[data-pack-prototype-continue]');
    const persistentPackCancel = sectionEl.querySelector('[data-pack-prototype-cancel]');

    const bundleCards = sectionEl.querySelectorAll('[data-bundle-open]');
    const bundlePacks = sectionEl.querySelector('[data-bundle-packs]');
    const bundleCta = sectionEl.querySelector('[data-bundle-cta]');
    const packPersonalizationDrawer = sectionEl.querySelector('[data-pack-personalization-drawer]');
    const packPersonalizationDrawerOpen = sectionEl.querySelector('[data-pack-personalization-drawer-open]');
    const packPersonalizationDrawerCloseButtons = sectionEl.querySelectorAll('[data-pack-personalization-drawer-close]');
    const packPersonalizationDrawerIframe = sectionEl.querySelector('[data-pack-personalization-drawer-iframe]');
    const bundlePersonalizationPanel = sectionEl.querySelector('[data-bundle-personalization-panel]');
    const bundlePersonalizationUpload = sectionEl.querySelector('[data-bundle-personalization-upload]');
    const bundlePersonalizationMessage = sectionEl.querySelector('[data-bundle-personalization-message]');
    const bundlePersonalizationConfirm = sectionEl.querySelector('[data-bundle-personalization-confirm]');
    const mediaWrapper = sectionEl.querySelector('.main-product__media-wrapper');
    const mediaColumn = mediaWrapper?.closest('.main-product__media');
    const packEditor = sectionEl.querySelector('[data-pack-editor]');
    const packEditorActions = sectionEl.querySelector('[data-pack-editor-actions]');
    const packEditorStage = sectionEl.querySelector('[data-pack-editor-stage]');
    const packEditorCanvas = sectionEl.querySelector('[data-pack-editor-canvas]');
    const packEditorPlaceholder = sectionEl.querySelector('[data-pack-editor-placeholder]');
    const packEditorCurrent = sectionEl.querySelector('[data-pack-editor-current]');
    const packEditorStatus = sectionEl.querySelector('[data-pack-editor-status]');
    const packEditorValidate = sectionEl.querySelector('[data-pack-editor-validate]');
    const packEditorValidateTop = sectionEl.querySelector('[data-pack-editor-validate-top]');
    const packEditorCancelTop = sectionEl.querySelector('[data-pack-editor-cancel-top]');
    const packEditorControls = sectionEl.querySelector('[data-pack-editor-controls]');
    const packEditorFormatButtons = sectionEl.querySelectorAll('[data-pack-editor-format]');
    const packEditorZoom = sectionEl.querySelector('[data-pack-editor-zoom]');
    const packEditorZoomValue = sectionEl.querySelector('[data-pack-editor-zoom-value]');
    const packEditorRotation = sectionEl.querySelector('[data-pack-editor-rotation]');
    const packEditorRotationValue = sectionEl.querySelector('[data-pack-editor-rotation-value]');

    const bundleModal = sectionEl.querySelector('[data-bundle-modal]');
    let bundleItems = Array.from(sectionEl.querySelectorAll('[data-bundle-item]'));
    const bundleSearch = sectionEl.querySelector('[data-bundle-search]');
    const bundleConfirm = sectionEl.querySelector('[data-bundle-confirm]');
    const bundleTitle = sectionEl.querySelector('[data-bundle-modal-title]');
    const bundleEmpty = sectionEl.querySelector('[data-bundle-empty]');
    const bundleFiltersWrap = sectionEl.querySelector('[data-bundle-filters-wrap]');
    const bundleFilters = sectionEl.querySelector('[data-bundle-filters]');
    const bundleFiltersPrev = sectionEl.querySelector('[data-bundle-filters-prev]');
    const bundleFiltersNext = sectionEl.querySelector('[data-bundle-filters-next]');
    const bundleGrid = sectionEl.querySelector('[data-bundle-grid]');
    const bundleLoadMoreButton = sectionEl.querySelector('[data-bundle-load-more]');
    const bundlePreview = sectionEl.querySelector('[data-bundle-preview-modal]');
    const bundlePreviewImage = sectionEl.querySelector('[data-bundle-preview-image]');
    const bundlePreviewTitle = sectionEl.querySelector('[data-bundle-preview-title]');
    const bundlePreviewCloseButtons = sectionEl.querySelectorAll('[data-bundle-preview-close]');

    const stickyAddToCart = sectionEl.querySelector('.sticky-add-to-cart');

    const FRAME_20_VARIANT_ID = Number(upsellEl?.dataset.frame20VariantId || 53566069997901);
    const FRAME_30_VARIANT_ID = Number(upsellEl?.dataset.frame30VariantId || 53566070325581);

    let selectedBundleCard = null;
    let currentBundleConfig = null;
    let selectedBundleProducts = [];
    const BEST_SELLERS_FILTER = 'best-sellers';
    let currentBundleFilter = BEST_SELLERS_FILTER;
    let shuffledBestSellerHandles = [];
    let bestSellerProductsPromise = null;
    const bestSellerProductsByHandle = new Map();
    let bundlePreviewTrigger = null;
    let isBundleLoading = false;
    let packEditorPreferredFormat = 'portrait';
    let packEditorOriginalFiles = [];
    const packEditorRejectedFileKeys = new Set();
    let packEditorUploadSyncTimer = null;
    let packEditorUploadRetryCount = 0;
    let packEditorState = {
      sources: [],
      sourceSignature: '',
      currentIndex: 0,
      currentSource: null,
      image: null,
      edits: [],
      imgbbUrls: [],
      format: 'portrait',
      zoom: 1,
      rotation: 0,
      offsetX: 0,
      offsetY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragOffsetX: 0,
      dragOffsetY: 0,
      completed: false
    };

    const desiredPackCards = [
      {
        key: 'pack-decouverte',
        tag: 'bundle-one-30x40',
        qty: '2',
        variantId: '53912966201677',
        title: 'Pack DÉCOUVERTE',
        className: 'bundle-pack-card--basic',
        badge: 'DÉCOUVERTE',
        heading: '1 cadre + 2 affiches boutique',
        comparePrice: '63,70 €',
        price: '49€'
      },
      {
        key: 'pack-boutique-trois',
        tag: 'bundle-one-30x40',
        qty: '3',
        variantId: '54081635549517',
        title: 'Pack ESSENTIEL',
        className: 'bundle-pack-card--essential',
        badge: 'ESSENTIEL',
        popular: 'LE PLUS POPULAIRE',
        heading: '1 cadre + 3 affiches boutique',
        comparePrice: '79,60 €',
        price: '59€'
      },
      {
        key: 'pack-famille',
        tag: 'bundle-three-30x40',
        qty: '6',
        variantId: '53912969609549',
        title: 'Pack FAMILLE',
        className: 'bundle-pack-card--signature',
        badge: 'FAMILLE',
        heading: '2 cadres + 6 affiches boutique',
        comparePrice: '159,20 €',
        price: '99€'
      }
    ];

    const getPackEditorUrlConfig = () => {
      if (!isPackDrawerMode) return null;

      const params = new URLSearchParams(window.location.search);
      const qty = Math.max(0, parseInt(params.get('pack_qty') || '', 10) || 0);
      const key = params.get('pack_key') || '';
      const variantId = params.get('pack_variant_id') || '';

      if (!qty || !key || !variantId) return null;

      return {
        key,
        qty,
        variantId,
        title: key === 'bundle-custom-one-30x40'
          ? 'Pack Découverte Personnalisé'
          : key === 'bundle-custom-three-30x40'
            ? 'Pack Famille Personnalisé'
            : 'Pack Essentiel Personnalisé'
      };
    };

    const packEditorUrlConfig = getPackEditorUrlConfig();
    const isPackEditorUrlPersonalization = () => Boolean(packEditorUrlConfig);
    const getRequiredPackImages = () => currentBundleConfig?.qty || packEditorUrlConfig?.qty || 3;
    const isCurrentPersonalizationBundle = () => (
      Boolean(packEditorUrlConfig && currentBundleConfig?.key === packEditorUrlConfig.key)
    );
    const applyPackEditorUrlConfigToCard = (card) => {
      if (!card || !packEditorUrlConfig) return;

      card.dataset.bundleKey = packEditorUrlConfig.key;
      card.dataset.bundleQty = String(packEditorUrlConfig.qty);
      card.dataset.bundleVariantId = packEditorUrlConfig.variantId;
      card.dataset.bundleTitle = packEditorUrlConfig.title;
    };

    const normalizePackPurchaseUi = () => {
      const grid = sectionEl.querySelector('.bundle-packs__grid');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-bundle-open]'));

      desiredPackCards.forEach((config, index) => {
        let card = cards[index];

        if (!card) {
          card = document.createElement('button');
          card.type = 'button';
          card.dataset.bundleOpen = '';
          grid.appendChild(card);
        }

        card.className = `bundle-pack-card ${config.className}`;
        card.type = 'button';
        card.dataset.bundleKey = config.key;
        card.dataset.bundleTag = config.tag || '';
        card.dataset.bundleQty = config.qty;
        card.dataset.bundleVariantId = config.variantId;
        card.dataset.bundleTitle = config.title;
        card.removeAttribute('data-bundle-disabled');

        card.innerHTML = `
          <span class="bundle-pack-card__badge">${config.badge}</span>
          ${config.popular ? `<span class="bundle-pack-card__popular">${config.popular}</span>` : ''}
          <span class="bundle-pack-card__price-row">
            <s class="bundle-pack-card__compare-price">${config.comparePrice}</s>
            <span class="bundle-pack-card__price">${config.price}</span>
          </span>
          <span class="bundle-pack-card__title">${config.heading}</span>
        `;
      });

      cards.slice(desiredPackCards.length).forEach((card) => card.remove());
    };

    normalizePackPurchaseUi();
    const packEditorCtx = packEditorCanvas ? packEditorCanvas.getContext('2d') : null;

    const MANUAL_BUNDLE_FILTERS = [
      { label: 'Animaux', value: 'filter-animaux' },
      { label: 'Astrologie', value: 'filter-astrologie' },
      { label: 'Citation', value: 'filter-citation' },
      { label: 'CulturePop90', value: 'filter-culturepop90' },
      { label: 'Humour', value: 'filter-humour' },
      { label: 'Nature', value: 'filter-nature' },
      { label: 'Streetfood', value: 'filter-streetfood' },
      { label: 'Summer', value: 'filter-summer' },
      { label: 'Synthwave', value: 'filter-synthwave' }
    ];

    const MANUAL_BUNDLE_FILTER_LABELS = MANUAL_BUNDLE_FILTERS.reduce((labels, filterObj) => {
      labels[filterObj.value] = filterObj.label;
      return labels;
    }, {});

    const SPECIAL_BUNDLE_FILTER_LABELS = {
      'filter-boutdumonde': 'BOUT DU MONDE'
    };

    const bundleFilterCatalogByBundleTag = {};
    const bundleFilterCatalogPromises = {};

    const formatBundleFilterLabel = (filterValue = '') => {
      if (SPECIAL_BUNDLE_FILTER_LABELS[filterValue]) return SPECIAL_BUNDLE_FILTER_LABELS[filterValue];
      if (MANUAL_BUNDLE_FILTER_LABELS[filterValue]) return MANUAL_BUNDLE_FILTER_LABELS[filterValue];

      return filterValue
        .replace(/^filter-/, '')
        .replace(/[-_]+/g, ' ')
        .trim()
        .toUpperCase();
    };

    const sortBundleFilters = (filters) => {
      return filters.sort((first, second) => first.label.localeCompare(second.label, 'fr', {
        numeric: true,
        sensitivity: 'base'
      }));
    };

    const getAvailableBundleFilters = (bundleTag, sourceItems = bundleItems, options = {}) => {
      const shouldUseFallback = options.fallback !== false;
      const filterMap = new Map();

      sourceItems.forEach((item) => {
        const tags = (item.dataset.productTags || '')
          .split('|')
          .map((tag) => tag.trim())
          .filter(Boolean);

        if (bundleTag && !tags.includes(bundleTag)) return;

        tags.forEach((tag) => {
          if (!tag.startsWith('filter-') || filterMap.has(tag)) return;
          filterMap.set(tag, {
            label: formatBundleFilterLabel(tag),
            value: tag
          });
        });
      });

      const dynamicFilters = sortBundleFilters(Array.from(filterMap.values()));

      if (dynamicFilters.length || !shouldUseFallback) {
        return dynamicFilters;
      }

      return MANUAL_BUNDLE_FILTERS;
    };

    const bundleLoadedPagesByFilter = {
      [BEST_SELLERS_FILTER]: 1
    };

    const MIN_VISIBLE_ITEMS_PER_FILTER = 8;
    const bundleHasMoreCache = {};

    const input20 = upsellEl ? upsellEl.querySelector('[data-frame-input="20x20"]') : null;
    const input30 = upsellEl ? upsellEl.querySelector('[data-frame-input="30x40"]') : null;
    const optionButtons = upsellEl ? upsellEl.querySelectorAll('[data-frame-option]') : [];
    const panels = upsellEl ? upsellEl.querySelectorAll('[data-frame-panel]') : [];

    const bundleOverlay = document.getElementById(`bundle-builder-overlay-${sectionId}`);
    const bundleCloseButton = document.getElementById(`bundle-builder-close-${sectionId}`);
    const bundleDialog = bundleModal ? bundleModal.querySelector('.bundle-builder__dialog') : null;

    const clampQty = (value) => {
      const parsed = parseInt(value, 10);
      if (Number.isNaN(parsed) || parsed < 0) return 0;
      if (parsed > 99) return 99;
      return parsed;
    };

    const updateQty = (input, value) => {
      if (!input) return;
      input.value = clampQty(value);
    };

    const resetFrameQty = () => {
      updateQty(input20, 0);
      updateQty(input30, 0);
    };

    const setActiveFrame = (key) => {
      optionButtons.forEach((btn) => {
        const isActive = btn.dataset.frameOption === key;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.framePanel === key);
      });
    };

    const hideBundleCta = () => {
      if (!bundleCta) return;
      bundleCta.hidden = true;
      bundleCta.classList.remove('is-active');
    };

    const showBundleCta = () => {
      if (!bundleCta) return;
      bundleCta.hidden = false;
      bundleCta.classList.remove('is-active');
    };

    const hidePackPersonalizationDrawerCta = () => {
      if (!packPersonalizationDrawerOpen) return;
      packPersonalizationDrawerOpen.hidden = true;
    };

    const showPackPersonalizationDrawerCta = () => {
      if (!packPersonalizationDrawerOpen) return;
      packPersonalizationDrawerOpen.hidden = false;
    };

    const isPersonalizationBundle = (card) => (
      Boolean(packEditorUrlConfig && card?.dataset.bundleKey === packEditorUrlConfig.key)
    );

    const showPersonalizationPanel = () => {
      if (!bundlePersonalizationPanel) return;
      if (!isPackDrawerMode) {
        bundlePersonalizationPanel.classList.remove('is-active');
        return;
      }
      bundlePersonalizationPanel.classList.add('is-active');
    };

    const hidePersonalizationPanel = () => {
      if (!bundlePersonalizationPanel) return;
      bundlePersonalizationPanel.classList.remove('is-active');
    };

    const setPersonalizationMessage = (message = '') => {
      if (!bundlePersonalizationMessage) return;

      bundlePersonalizationMessage.textContent = message;
      bundlePersonalizationMessage.hidden = !message;
    };

    const buildBundleConfigFromCard = (card) => {
      if (!card) return null;

      return {
        key: card.dataset.bundleKey || '',
        tag: card.dataset.bundleTag || '',
        qty: clampQty(card.dataset.bundleQty || 0),
        variantId: card.dataset.bundleVariantId || '',
        title: card.dataset.bundleTitle || ''
      };
    };

    const resetBundleSelection = () => {
      selectedBundleCard = null;
      currentBundleConfig = null;
      setPersonalizationMessage('');

      bundleCards.forEach((item) => {
        item.classList.remove('is-selected');
        item.classList.remove('is-active');
      });

      hideBundleCta();
      hidePackPersonalizationDrawerCta();
      hidePersonalizationPanel();
      resetPackEditorState();
    };

    const setSelectedBundle = (card) => {
      bundleCards.forEach((item) => {
        const isCurrent = item === card;
        item.classList.toggle('is-selected', isCurrent);
        item.classList.toggle('is-active', isCurrent);
      });

      selectedBundleCard = card || null;

      setPersonalizationMessage('');
      currentBundleConfig = buildBundleConfigFromCard(selectedBundleCard);

      if (selectedBundleCard && isPersonalizationBundle(selectedBundleCard)) {
        hideBundleCta();
        showPackPersonalizationDrawerCta();
        showPersonalizationPanel();
        syncPackEditorWithUploads().catch((error) => console.error('[pack-editor] sync selection erreur =', error));
      } else if (selectedBundleCard) {
        hidePackPersonalizationDrawerCta();
        hidePersonalizationPanel();
        resetPackEditorState();
        updatePackPersonalizationConfirmState();
        showBundleCta();
      } else {
        hidePackPersonalizationDrawerCta();
        hidePersonalizationPanel();
        resetPackEditorState();
        updatePackPersonalizationConfirmState();
        hideBundleCta();
      }
    };

    const selectDefaultPack = () => {
      const defaultCard =
        sectionEl.querySelector('[data-bundle-key="pack-boutique-trois"]') ||
        sectionEl.querySelector('[data-bundle-open]');
      if (!defaultCard) {
        hideBundleCta();
        return;
      }

      applyPackEditorUrlConfigToCard(defaultCard);
      setSelectedBundle(defaultCard);
    };

    const readPersistentPackContext = () => {
      return window.FriziPackContext?.read() || null;
    };

    const writePersistentPackContext = (context) => {
      return Boolean(window.FriziPackContext?.write(context));
    };

    const clearPersistentPackContext = () => {
      window.FriziPackContext?.clear();
    };

    const getCurrentPrototypePoster = () => {
      const id = purchaseMode?.dataset.packPrototypeProductId || '';
      const handle = purchaseMode?.dataset.packPrototypeProductHandle || '';
      if (!id || !handle) return null;

      return {
        id: String(id),
        handle: String(handle),
        title: purchaseMode?.dataset.packPrototypeProductTitle || document.title || '',
        image: purchaseMode?.dataset.packPrototypeProductImage || '',
        variantId: purchaseMode?.dataset.packPrototypeProductVariantId || ''
      };
    };

    const getSafePersistentPosterImageUrl = (value) => {
      if (!value) return '';

      try {
        const url = new URL(value, window.location.origin);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
      } catch (error) {
        return '';
      }
    };

    const renderPersistentPackThumbnails = (posters) => {
      if (!persistentPackThumbnails) return;

      persistentPackThumbnails.replaceChildren();
      persistentPackThumbnails.hidden = posters.length === 0;

      posters.forEach((poster) => {
        const thumbnail = document.createElement('span');
        thumbnail.className = 'bundle-packs__prototype-thumbnail';

        const imageUrl = getSafePersistentPosterImageUrl(poster.image);
        if (!imageUrl) {
          thumbnail.classList.add('bundle-packs__prototype-thumbnail--fallback');
          thumbnail.setAttribute('aria-hidden', 'true');
          persistentPackThumbnails.append(thumbnail);
          return;
        }

        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = poster.title || 'Affiche sélectionnée';
        image.decoding = 'async';
        image.addEventListener('error', () => {
          thumbnail.classList.add('bundle-packs__prototype-thumbnail--fallback');
          image.remove();
        }, { once: true });
        thumbnail.append(image);
        persistentPackThumbnails.append(thumbnail);
      });
    };

    const updatePersistentPackContextUI = () => {
      const context = readPersistentPackContext();
      const currentPoster = getCurrentPrototypePoster();
      const hasContext = Boolean(context && currentPoster && persistentPackContext);

      bundlePacks?.classList.toggle('has-pack-prototype-context', hasContext);
      if (persistentPackContext) persistentPackContext.hidden = !hasContext;
      if (!hasContext) {
        renderPersistentPackThumbnails([]);
        return null;
      }

      const selectedPosters = context.selectedPosters;
      renderPersistentPackThumbnails(selectedPosters);
      const selectedCurrentPoster = selectedPosters.some((poster) => poster.id === currentPoster.id);
      const isComplete = selectedPosters.length >= context.requiredPosters;
      const countLabel = `${selectedPosters.length}/${context.requiredPosters} affiche${context.requiredPosters > 1 ? 's' : ''} sélectionnée${context.requiredPosters > 1 ? 's' : ''}`;

      if (persistentPackTitle) persistentPackTitle.textContent = `VOTRE ${context.title.toUpperCase()}`;
      if (persistentPackProgress) {
        persistentPackProgress.textContent = isComplete
          ? `✓ ${countLabel} — PACK COMPLET`
          : countLabel;
        persistentPackProgress.classList.toggle('is-complete', isComplete);
      }
      if (persistentPackContinue) {
        persistentPackContinue.hidden = false;
        persistentPackContinue.textContent = 'REPRENDRE LA COMPOSITION DU PACK';
      }

      if (persistentPackAdd) {
        persistentPackAdd.hidden = selectedCurrentPoster || isComplete;
        persistentPackAdd.disabled = selectedCurrentPoster || isComplete;
        persistentPackAdd.textContent = isComplete ? 'PACK COMPLET' : 'AJOUTER CETTE AFFICHE AU PACK';
      }

      if (persistentPackFinalize) {
        persistentPackFinalize.hidden = !isComplete;
        persistentPackFinalize.disabled = !isComplete;
      }

      return context;
    };

    const resumePersistentPackComposition = () => {
      openPersistentFullSelector();
    };

    const addCurrentPosterToPersistentPack = async () => {
      const context = readPersistentPackContext();
      const currentPoster = getCurrentPrototypePoster();
      if (!context || !currentPoster) return;

      if (context.selectedPosters.some((poster) => poster.id === currentPoster.id)) {
        updatePersistentPackContextUI();
        return;
      }

      if (context.selectedPosters.length >= context.requiredPosters) {
        updatePersistentPackContextUI();
        return;
      }

      context.selectedPosters.push(currentPoster);
      writePersistentPackContext(context);
      updatePersistentPackContextUI();

      if (context.selectedPosters.length === context.requiredPosters) {
        if (!hydratePersistentPackSelection(context)) return;

        try {
          await finalizeBundlePack();
        } catch (error) {
          console.error('[pack-prototype] finalisation directe impossible', error);
          alert(error.message || "Impossible d'ajouter le pack au panier.");
          openPersistentFullSelector();
        }
        return;
      }

      openPersistentFullSelector();
    };

    const isBundleCardDisabled = (card) => card?.dataset.bundleDisabled === 'true';

    const setPurchaseMode = (key) => {
      sectionEl.dataset.packPurchaseMode = key;
      if (purchaseMode) purchaseMode.dataset.activePurchaseMode = key;
      setPackEditorVisible(key === 'packs');

      purchaseTabs.forEach((tab) => {
        const isActive = tab.dataset.purchaseTab === key;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      purchasePanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.purchasePanel === key);
      });

      if (key !== 'packs') {
        resetBundleSelection();
        if (key === 'simple') {
          requestAnimationFrame(() => activatePosterOnlySimpleMode());
        }
      } else if (!selectedBundleCard) {
        selectDefaultPack();
      }
    };

    const openMiniCart = () => {
      const miniCart = document.getElementById('mini-cart');
      if (!miniCart) return;

      if (typeof miniCart.open === 'function') {
        miniCart.open();
        return;
      }

      miniCart.classList.add('open', 'active', 'is-open');
      miniCart.setAttribute('open', 'open');
      miniCart.setAttribute('aria-hidden', 'false');
    };

    const cleanPackCartOpenUrl = () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('pack_cart_open');
      const nextHash = url.hash === '#pack-cart-open' ? '' : url.hash;
      const nextUrl = `${url.pathname}${url.search}${nextHash}`;
      window.history.replaceState({}, document.title, nextUrl || window.location.pathname);
    };

    const openMiniCartFromPackReturn = () => {
      const params = new URLSearchParams(window.location.search);
      const shouldOpenCart = params.get('pack_cart_open') === '1' || window.location.hash === '#pack-cart-open';

      if (!shouldOpenCart) return;

      try {
        sessionStorage.removeItem(PACK_RETURN_STORAGE_KEY);
      } catch (error) {
        console.warn('[pack-editor] nettoyage URL retour impossible', error);
      }

      cleanPackCartOpenUrl();
      window.setTimeout(() => {
        refreshMiniCartSafely().catch((error) => {
          console.error('[pack-editor] ouverture mini-cart après retour mobile impossible', error);
          openMiniCart();
        });
      }, 120);
    };

    const refreshMiniCartSafely = async () => {
      const miniCart = document.getElementById('mini-cart');
      if (!miniCart) return;

      const [cartResponse, sectionResponse] = await Promise.all([
        fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        }),
        fetch(`/cart?section_id=main-cart&_ts=${Date.now()}`, {
          headers: { Accept: 'text/html' },
          cache: 'no-store'
        })
      ]);

      const cart = await cartResponse.json();
      const html = await sectionResponse.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      if (window.cartService && typeof window.cartService.renderElements === 'function') {
        window.cartService.renderElements(parsed);
      }

      const currentItemsContainer =
        miniCart.querySelector('.cart-items-container') ||
        miniCart.querySelector('.mini-cart--empty') ||
        miniCart.querySelector('.cart__empty');

      let freshItemsContainer = null;

      if (cart.item_count > 0) {
        freshItemsContainer = parsed.querySelector('.cart-items-container');
      } else {
        freshItemsContainer =
          parsed.querySelector('.mini-cart--empty') ||
          parsed.querySelector('.cart__empty');
      }

      if (freshItemsContainer && currentItemsContainer) {
        currentItemsContainer.replaceWith(freshItemsContainer.cloneNode(true));
      } else if (freshItemsContainer) {
        const target =
          miniCart.querySelector('.mini-cart__content') ||
          miniCart.querySelector('.cart-summary') ||
          miniCart;

        target.insertBefore(freshItemsContainer.cloneNode(true), target.firstChild);
      }

      const currentSummary =
        miniCart.querySelector('.cart-summary') ||
        miniCart.querySelector('.mini-cart__footer') ||
        miniCart.querySelector('form[action="/cart"]');

      const freshSummary =
        parsed.querySelector('.cart-summary') ||
        parsed.querySelector('.mini-cart__footer') ||
        parsed.querySelector('form[action="/cart"]');

      if (currentSummary && freshSummary) {
        currentSummary.replaceWith(freshSummary.cloneNode(true));
      }

      miniCart.querySelectorAll('.icon').forEach((icon) => {
        icon.classList.add('loaded');
      });

      if (window.cartService && typeof window.cartService.manageState === 'function') {
        miniCart.querySelectorAll('.cart-item').forEach((item) => {
          window.cartService.manageState(item);
        });
      }

      openMiniCart();
    };

    openMiniCartFromPackReturn();

    const bindNativeAddToCartRefresh = () => {
      const nativeAtcButtons = sectionEl.querySelectorAll(
        '.button--add-to-cart:not([data-frames-only-atc]), [name="add"]:not([data-frames-only-atc])'
      );

      nativeAtcButtons.forEach((button) => {
        if (button.dataset.miniCartRefreshBound === 'true') return;
        button.dataset.miniCartRefreshBound = 'true';

        button.addEventListener('click', () => {
          setTimeout(() => {
            refreshMiniCartSafely().catch((error) => {
              console.error('[native-atc] refresh mini-cart failed (pass 1) =', error);
            });
          }, 700);

          setTimeout(() => {
            refreshMiniCartSafely().catch((error) => {
              console.error('[native-atc] refresh mini-cart failed (pass 2) =', error);
            });
          }, 1400);
        });
      });
    };

    const syncStickyVisibility = () => {
      if (!stickyAddToCart) return;

      const hideThreshold = 400;
      const shouldHide = window.scrollY < hideThreshold;

      stickyAddToCart.classList.toggle('is-hidden-by-scroll', shouldHide);
    };

    const setBundleUpdatingState = (isUpdating) => {
      if (bundleGrid) {
        bundleGrid.classList.toggle('is-updating', isUpdating);
      }

      const bundleContent = sectionEl.querySelector('.bundle-builder__content');
      if (bundleContent) {
        bundleContent.classList.toggle('is-updating', isUpdating);
      }

      if (bundleEmpty && isUpdating) {
        bundleEmpty.hidden = true;
      }
    };

    const refreshBundleItemsCache = () => {
      bundleItems = Array.from(sectionEl.querySelectorAll('[data-bundle-item]'));
    };

    const restoreSelectedVisualState = () => {
      const selectedIds = new Set(selectedBundleProducts.map((product) => String(product.id)));

      bundleItems.forEach((item) => {
        const isSelected = selectedIds.has(String(item.dataset.productId));
        item.classList.toggle('is-selected', isSelected);

        const button = item.querySelector('[data-bundle-select]');
        if (button) {
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        }
      });
    };

    const clearBundleModalSelection = () => {
      selectedBundleProducts = [];

      bundleItems.forEach((item) => {
        item.classList.remove('is-selected');
        const button = item.querySelector('[data-bundle-select]');
        if (button) button.setAttribute('aria-pressed', 'false');
      });
    };

    const getCurrentBundleQty = () => currentBundleConfig?.qty || 0;
    const getCurrentBundleTag = () => currentBundleConfig?.tag || '';
    const getCurrentFilterKey = () => {
      const tag = getCurrentBundleTag();
      const filter = currentBundleFilter || BEST_SELLERS_FILTER;

      return `${tag || 'bundle'}::${filter}`;
    };

    const getLoadedPageForFilter = (filterKey) => {
      return Number(bundleLoadedPagesByFilter[filterKey] || 1);
    };

    const setLoadedPageForFilter = (filterKey, page) => {
      bundleLoadedPagesByFilter[filterKey] = Number(page || 1);
    };

    const clearBundleHasMoreCache = () => {
      Object.keys(bundleHasMoreCache).forEach((key) => {
        delete bundleHasMoreCache[key];
      });
    };

    const syncPersistentPackSelections = () => {
      const context = readPersistentPackContext();
      if (!context || context.key !== currentBundleConfig?.key) return;

      context.selectedPosters = selectedBundleProducts.map((product) => ({
        id: String(product.id || ''),
        handle: product.handle || '',
        title: product.title || '',
        variantId: String(product.variantId || ''),
        image: product.image || ''
      })).filter((product) => product.id && product.handle);
      writePersistentPackContext(context);
    };

    const startPersistentPackFromProduct = () => {
      const existingContext = readPersistentPackContext();
      if (existingContext) return existingContext;
      if (!currentBundleConfig?.key || !currentBundleConfig.qty) return null;

      return window.FriziPackContext?.write({
        version: 1,
        key: currentBundleConfig.key,
        title: currentBundleConfig.title,
        requiredPosters: currentBundleConfig.qty,
        variantId: currentBundleConfig.variantId,
        requiredTag: currentBundleConfig.tag,
        shopUrl: persistentPackContinue?.href || window.routes?.all_products_collection_url || '/collections/all',
        composerUrl: `${window.location.origin}${window.location.pathname}${window.location.search}`,
        resumeTarget: 'full-selector',
        selectedPosters: []
      }) || null;
    };

    const shuffleBestSellers = () => {
      shuffledBestSellerHandles = [...(window.FRIZI_BEST_SELLERS || [])];

      for (let index = shuffledBestSellerHandles.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffledBestSellerHandles[index], shuffledBestSellerHandles[randomIndex]] = [
          shuffledBestSellerHandles[randomIndex],
          shuffledBestSellerHandles[index]
        ];
      }
    };

    const initPosterOnlySimpleMode = () => {
      if (isPackDrawerMode) return () => {};

      const picker = sectionEl.querySelector(
        '[data-purchase-panel="simple"] [data-purchase-simple] variant-selects'
      );
      if (!picker || picker.dataset.friziPosterOnlyReady === 'true') return () => {};

      const variantsScript = picker.querySelector('script[type="application/json"]');
      if (!variantsScript) return () => {};

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.error('[affiches] JSON variants illisible', error);
        return () => {};
      }

      const normalize = (value = '') => String(value)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      const groups = Array.from(picker.querySelectorAll('.variant-step'))
        .sort((first, second) => {
          const firstPosition = Number(first.querySelector('[data-option-position]')?.dataset.optionPosition || 0);
          const secondPosition = Number(second.querySelector('[data-option-position]')?.dataset.optionPosition || 0);
          return firstPosition - secondPosition;
        });

      const getControl = (group) => group?.querySelector('[data-option-position]');
      const getPosition = (group) => Number(getControl(group)?.dataset.optionPosition || 0);
      const getName = (group) => normalize(
        group?.querySelector('legend, :scope > label')?.textContent || ''
      );
      const getValue = (group) => {
        const control = getControl(group);
        if (!control) return '';
        if (control.tagName === 'SELECT') return control.value || '';
        return control.querySelector('input[type="radio"]:checked')?.value || '';
      };
      const getValues = (group) => {
        const control = getControl(group);
        if (!control) return [];
        if (control.tagName === 'SELECT') {
          return Array.from(control.options)
            .map((option) => option.value)
            .filter(Boolean);
        }
        return Array.from(control.querySelectorAll('input[type="radio"]')).map((input) => input.value);
      };
      const setValue = (group, value) => {
        const control = getControl(group);
        if (!control || !value || getValue(group) === value) return false;

        if (control.tagName === 'SELECT') {
          const option = Array.from(control.options).find((item) => item.value === value && !item.disabled);
          if (!option) return false;
          control.value = value;
          control.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }

        const input = Array.from(control.querySelectorAll('input[type="radio"]'))
          .find((item) => item.value === value && !item.disabled);
        if (!input) return false;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      };

      const optionsGroup = groups.find((group) => getName(group) === 'options');
      const formatGroup = groups.find((group) => getName(group) === 'format');
      const sizeGroup = groups.find((group) => getName(group) === 'taille');
      const posterOnlyValue = getValues(optionsGroup)
        .find((value) => normalize(value).includes('affiche seule'));

      if (!optionsGroup || !posterOnlyValue) return () => {};

      optionsGroup.dataset.friziPosterOnlyOptions = 'true';
      picker.classList.add('frizi-poster-only-picker');
      picker.dataset.friziPosterOnlyReady = 'true';

      const getSelections = () => new Map(groups.map((group) => [getPosition(group), getValue(group)]));
      const findCompatibleValue = (group, preferredValue = '') => {
        if (!group) return '';
        const position = getPosition(group);
        const selections = getSelections();
        const matchingVariants = variants.filter((variant) => {
          if (!variant.available) return false;
          return groups.every((candidate) => {
            const candidatePosition = getPosition(candidate);
            const selectedValue = selections.get(candidatePosition);
            if (!selectedValue || candidate === group) return true;
            return variant.options?.[candidatePosition - 1] === selectedValue;
          });
        });
        const values = matchingVariants
          .map((variant) => variant.options?.[position - 1])
          .filter(Boolean);
        return values.includes(preferredValue) ? preferredValue : (values[0] || '');
      };

      let syncing = false;
      let rememberedSize = getValue(sizeGroup);

      const activatePosterOnlySelection = () => {
        syncing = true;
        const preferredFormat = getValue(formatGroup);
        const preferredSize = getValue(sizeGroup) || rememberedSize;

        setValue(optionsGroup, posterOnlyValue);

        const nextFormat = findCompatibleValue(formatGroup, preferredFormat);
        if (nextFormat) setValue(formatGroup, nextFormat);

        const nextSize = findCompatibleValue(sizeGroup, preferredSize);
        if (nextSize) {
          setValue(sizeGroup, nextSize);
          rememberedSize = nextSize;
        }
        syncing = false;
      };

      picker.addEventListener('change', (event) => {
        if (syncing) return;
        const changedGroup = event.target.closest('.variant-step');
        if (!changedGroup) return;

        if (changedGroup === sizeGroup) rememberedSize = getValue(sizeGroup);

        if (changedGroup === formatGroup) {
          const preferredSize = rememberedSize;
          requestAnimationFrame(() => {
            syncing = true;
            setValue(optionsGroup, posterOnlyValue);
            const nextSize = findCompatibleValue(sizeGroup, preferredSize);
            if (nextSize) {
              setValue(sizeGroup, nextSize);
              rememberedSize = nextSize;
            }
            syncing = false;
          });
        }
      }, true);

      const simpleTab = sectionEl.querySelector('[data-purchase-tab="simple"]');
      simpleTab?.addEventListener('click', () => {
        requestAnimationFrame(activatePosterOnlySelection);
      });

      return activatePosterOnlySelection;
    };

    const activatePosterOnlySimpleMode = initPosterOnlySimpleMode();

    const matchesCurrentBundleFilter = (item, tags) => {
      if (currentBundleFilter === BEST_SELLERS_FILTER) {
        return shuffledBestSellerHandles.includes(item.dataset.productHandle || '');
      }

      return currentBundleFilter === 'all' || tags.includes(currentBundleFilter);
    };

    const getBestSellerProductUrl = (handle) => {
      const rootUrl = window.routes?.root_url || '/';
      const rootPath = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;

      return `${rootPath}products/${encodeURIComponent(handle)}.js`;
    };

    const fetchBestSellerProducts = () => {
      if (bestSellerProductsPromise) return bestSellerProductsPromise;

      const handles = [...(window.FRIZI_BEST_SELLERS || [])];
      bestSellerProductsPromise = Promise.allSettled(
        handles.map(async (handle) => {
          const response = await fetch(getBestSellerProductUrl(handle), {
            headers: { Accept: 'application/json' },
            cache: 'force-cache'
          });

          if (!response.ok) throw new Error(`Produit Best Seller introuvable : ${handle}`);

          const product = await response.json();
          bestSellerProductsByHandle.set(handle, product);
        })
      ).then((results) => {
        results.forEach((result) => {
          if (result.status === 'rejected') {
            console.error('[bundle-best-sellers] chargement impossible =', result.reason);
          }
        });

        return bestSellerProductsByHandle;
      });

      return bestSellerProductsPromise;
    };

    const createBestSellerCard = (product) => {
      const tags = Array.isArray(product.tags) ? product.tags : [];
      const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
      if (!product.id || !product.handle || !variant) return null;

      const card = document.createElement('article');
      card.className = 'bundle-builder-card';
      card.dataset.bundleItem = '';
      card.dataset.productId = product.id;
      card.dataset.productHandle = product.handle;
      card.dataset.productTitle = product.title || '';
      card.dataset.productTags = tags.join('|');
      card.dataset.productVariantId = variant.id;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bundle-builder-card__button';
      button.dataset.bundleSelect = '';
      button.setAttribute('aria-pressed', 'false');

      const media = document.createElement('div');
      media.className = 'bundle-builder-card__media';
      const imageUrl = product.featured_image || product.images?.[0];

      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'bundle-builder-card__image';
        image.width = 300;
        image.loading = 'lazy';
        image.alt = product.media?.[0]?.alt || '';
        image.src = `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=600`;
        media.appendChild(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'bundle-builder-card__image bundle-builder-card__image--placeholder';
        media.appendChild(placeholder);
      }

      const badges = [
        ['ia', 'bundle-builder-card__badge--ia', 'CRÉATION IA'],
        ['artiste', 'bundle-builder-card__badge--artiste', 'COLLABORATION ARTISTE'],
        ['frizi', 'bundle-builder-card__badge--frizi', 'DESIGN FRIZI']
      ].filter(([tag]) => tags.includes(tag));

      if (badges.length) {
        const badgesWrap = document.createElement('div');
        badgesWrap.className = 'bundle-builder-card__badges';
        badgesWrap.setAttribute('aria-label', 'Badges produit');
        badges.forEach(([, className, label]) => {
          const badge = document.createElement('span');
          badge.className = `bundle-builder-card__badge ${className}`;
          badge.textContent = label;
          badgesWrap.appendChild(badge);
        });
        media.appendChild(badgesWrap);
      }

      const check = document.createElement('span');
      check.className = 'bundle-builder-card__check';
      check.textContent = 'Sélectionnée';
      media.appendChild(check);

      const info = document.createElement('div');
      info.className = 'bundle-builder-card__info';
      const title = document.createElement('p');
      title.className = 'bundle-builder-card__title';
      title.textContent = product.title || '';
      info.appendChild(title);

      button.append(media, info);
      card.appendChild(button);

      const previewButton = document.createElement('button');
      previewButton.type = 'button';
      previewButton.className = 'bundle-builder-card__preview';
      previewButton.dataset.bundlePreview = '';
      previewButton.setAttribute('aria-label', "Voir l'affiche en grand");
      previewButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"></path><circle cx="12" cy="12" r="2.5" fill="none" stroke="currentColor" stroke-width="1.8"></circle></svg>';
      card.appendChild(previewButton);

      return card;
    };

    const renderBestSellers = async () => {
      if (!bundleGrid || currentBundleFilter !== BEST_SELLERS_FILTER) return 0;

      if (!shuffledBestSellerHandles.length) shuffleBestSellers();
      await fetchBestSellerProducts();
      if (currentBundleFilter !== BEST_SELLERS_FILTER) return 0;

      const requiredTag = getCurrentBundleTag();
      const fragment = document.createDocumentFragment();

      shuffledBestSellerHandles.forEach((handle) => {
        const product = bestSellerProductsByHandle.get(handle);
        if (!product || (requiredTag && !product.tags?.includes(requiredTag))) return;

        const card = createBestSellerCard(product);
        if (card) fragment.appendChild(card);
      });

      bundleGrid.replaceChildren(fragment);
      bundleGrid.dataset.currentPage = '1';
      bundleGrid.dataset.pages = '1';
      refreshBundleItemsCache();
      bindBundleItemEvents(bundleGrid);
      restoreSelectedVisualState();
      return filterBundleItems();
    };

    const updateBundleFilterScrollEnd = () => {
      if (!bundleFilters) return;

      const maxScrollLeft = Math.max(0, bundleFilters.scrollWidth - bundleFilters.clientWidth);
      const hasOverflow = maxScrollLeft > 4;
      const atStart = !hasOverflow || bundleFilters.scrollLeft <= 4;
      const atEnd = !hasOverflow || bundleFilters.scrollLeft >= maxScrollLeft - 4;
      bundleFilters.classList.toggle('is-scroll-end', atEnd);

      if (bundleFiltersPrev) {
        bundleFiltersPrev.hidden = !hasOverflow || atStart;
      }

      if (bundleFiltersNext) {
        bundleFiltersNext.hidden = !hasOverflow || atEnd;
      }
    };

    const openBundlePreview = (card, trigger) => {
      if (!bundlePreview || !bundlePreviewImage || !card) return;

      const cardImage = card.querySelector('.bundle-builder-card__image');
      const imageUrl = cardImage?.currentSrc || cardImage?.src;
      if (!imageUrl) return;

      bundlePreviewTrigger = trigger || null;
      bundlePreviewImage.src = imageUrl;
      bundlePreviewImage.alt = cardImage?.alt || card.dataset.productTitle || '';
      if (bundlePreviewTitle) bundlePreviewTitle.textContent = card.dataset.productTitle || '';
      bundlePreview.hidden = false;
      bundlePreview.removeAttribute('hidden');
      bundlePreview.querySelector('.bundle-builder__preview-close')?.focus();
    };

    const closeBundlePreview = () => {
      if (!bundlePreview || bundlePreview.hidden) return;

      bundlePreview.hidden = true;
      bundlePreview.setAttribute('hidden', '');
      bundlePreviewImage?.removeAttribute('src');
      if (bundlePreviewTitle) bundlePreviewTitle.textContent = '';
      bundlePreviewTrigger?.focus();
      bundlePreviewTrigger = null;
    };

    const renderBundleFilters = (filters) => {
      if (!bundleFilters || !bundleFiltersWrap) return;

      const bundleTag = getCurrentBundleTag();
      const filtersToRender = filters || bundleFilterCatalogByBundleTag[bundleTag] || getAvailableBundleFilters(bundleTag);

      bundleFilters.innerHTML = '';

      const createButton = (label, value, isActive = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `bundle-builder__filter-btn${isActive ? ' is-active' : ''}`;
        button.textContent = label;
        button.dataset.bundleFilter = value;
        return button;
      };

      bundleFiltersWrap.hidden = false;

      bundleFilters.appendChild(
        createButton('BEST SELLERS', BEST_SELLERS_FILTER, currentBundleFilter === BEST_SELLERS_FILTER)
      );

      filtersToRender.forEach((filterObj) => {
        bundleFilters.appendChild(
          createButton(
            filterObj.label,
            filterObj.value,
            currentBundleFilter === filterObj.value
          )
        );
      });

      updateBundleFilterScrollEnd();
      window.requestAnimationFrame(updateBundleFilterScrollEnd);
    };

    if (bundleFilters) {
      bundleFilters.addEventListener('scroll', updateBundleFilterScrollEnd, { passive: true });
      window.addEventListener('resize', updateBundleFilterScrollEnd);
      window.addEventListener('load', updateBundleFilterScrollEnd);
    }

    const setBundleFilterCatalog = (bundleTag, filters) => {
      if (!bundleTag || !filters.length) return;

      bundleFilterCatalogByBundleTag[bundleTag] = filters;

      if (bundleTag === getCurrentBundleTag()) {
        renderBundleFilters(filters);
      }
    };

    const updateBundleModalUI = () => {
      const max = getCurrentBundleQty();
      const count = selectedBundleProducts.length;

      if (bundleConfirm) {
        if (count < max) {
          bundleConfirm.disabled = true;
          bundleConfirm.textContent = `${count} / ${max} affiches sélectionnées`;
        } else {
          bundleConfirm.disabled = false;
          bundleConfirm.textContent = `Valider le pack · ${count} / ${max}`;
        }
      }
    };

    const buildMoreCacheKey = () => {
      const requiredTag = getCurrentBundleTag();
      const searchValue = (bundleSearch?.value || '').trim().toLowerCase();
      const filterKey = getCurrentFilterKey();
      const currentPage = getLoadedPageForFilter(filterKey);

      return [
        requiredTag || '',
        filterKey || 'all',
        searchValue || '',
        currentPage
      ].join('::');
    };

    const pageHasMatchingItems = (gridEl) => {
      if (!gridEl) return false;

      const requiredTag = getCurrentBundleTag();
      const searchValue = (bundleSearch?.value || '').trim().toLowerCase();

      const items = Array.from(gridEl.querySelectorAll('[data-bundle-item]'));

      return items.some((item) => {
        const rawTags = item.dataset.productTags || '';
        const tags = rawTags.split('|').map((tag) => tag.trim()).filter(Boolean);
        const title = (item.dataset.productTitle || '').toLowerCase();

        const matchesBundle = requiredTag ? tags.includes(requiredTag) : true;
        const matchesFilter = matchesCurrentBundleFilter(item, tags);
        const matchesSearch = searchValue ? title.includes(searchValue) : true;

        return matchesBundle && matchesFilter && matchesSearch;
      });
    };

    const checkIfMoreMatchingItemsExist = async () => {
      if (!bundleGrid) return false;

      const cacheKey = buildMoreCacheKey();
      if (typeof bundleHasMoreCache[cacheKey] !== 'undefined') {
        return bundleHasMoreCache[cacheKey];
      }

      const filterKey = getCurrentFilterKey();
      const currentPage = getLoadedPageForFilter(filterKey);
      const totalPages = Number(bundleGrid.dataset.pages || 1);

      if (currentPage >= totalPages) {
        bundleHasMoreCache[cacheKey] = false;
        return false;
      }

      for (let page = currentPage + 1; page <= totalPages; page += 1) {
        try {
          const url = `${window.location.pathname}?section_id=${sectionId}&page=${page}&_ts=${Date.now()}`;
          const response = await fetch(url, {
            headers: { Accept: 'text/html' },
            cache: 'no-store'
          });

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newSection = parsed.getElementById(`shopify-section-${sectionId}`);
          if (!newSection) continue;

          const testGrid = newSection.querySelector('[data-bundle-grid]');
          if (!testGrid) continue;

          if (pageHasMatchingItems(testGrid)) {
            bundleHasMoreCache[cacheKey] = true;
            return true;
          }
        } catch (error) {
          console.error('[bundle-more-check] erreur détaillée =', error);
          break;
        }
      }

      bundleHasMoreCache[cacheKey] = false;
      return false;
    };

    const updateLoadMoreVisibility = async () => {
      if (!bundleLoadMoreButton || !bundleGrid) return;

      if (currentBundleFilter === BEST_SELLERS_FILTER) {
        bundleLoadMoreButton.hidden = true;
        bundleLoadMoreButton.disabled = false;
        bundleLoadMoreButton.textContent = 'Charger plus';
        return;
      }

      if (isBundleLoading) {
        bundleLoadMoreButton.hidden = false;
        bundleLoadMoreButton.disabled = true;
        bundleLoadMoreButton.textContent = 'Chargement...';
        return;
      }

      const hasMore = await checkIfMoreMatchingItemsExist();

      bundleLoadMoreButton.hidden = !hasMore;

      if (hasMore) {
        bundleLoadMoreButton.disabled = false;
        bundleLoadMoreButton.textContent = 'Charger plus';
      }
    };

    const filterBundleItems = () => {
      if (!bundleItems.length) {
        if (bundleEmpty) {
          bundleEmpty.hidden = true;
        }
        return 0;
      }

      const requiredTag = getCurrentBundleTag();
      const searchValue = (bundleSearch?.value || '').trim().toLowerCase();

      let visibleCount = 0;

      bundleItems.forEach((item) => {
        const rawTags = item.dataset.productTags || '';
        const tags = rawTags.split('|').map((tag) => tag.trim()).filter(Boolean);
        const title = (item.dataset.productTitle || '').toLowerCase();

        const matchesBundle = requiredTag ? tags.includes(requiredTag) : true;
        const matchesFilter = matchesCurrentBundleFilter(item, tags);
        const matchesSearch = searchValue ? title.includes(searchValue) : true;
        const shouldShow = matchesBundle && matchesFilter && matchesSearch;

        item.hidden = !shouldShow;

        if (shouldShow) visibleCount += 1;
      });

      if (bundleEmpty) {
        bundleEmpty.hidden = isBundleLoading || visibleCount > 0;
      }

      return visibleCount;
    };

    const bindBundleItemEvents = (scope = sectionEl) => {
      const items = scope.querySelectorAll('[data-bundle-item]');

      items.forEach((item) => {
        const button = item.querySelector('[data-bundle-select]');
        if (!button || button.dataset.bundleSelectBound === 'true') return;

        button.dataset.bundleSelectBound = 'true';
        button.addEventListener('click', () => {
          toggleBundleProduct(item);
        });
      });
    };

    const fetchBundlePageItems = async (pageToLoad) => {
      const url = `${window.location.pathname}?section_id=${sectionId}&page=${pageToLoad}&_ts=${Date.now()}`;
      const response = await fetch(url, {
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      });

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newSection = parsed.getElementById(`shopify-section-${sectionId}`);
      if (!newSection) throw new Error('Section introuvable dans la réponse Shopify.');

      const newGrid = newSection.querySelector('[data-bundle-grid]');
      if (!newGrid) throw new Error('Grille bundle introuvable dans la réponse.');

      return {
        items: Array.from(newGrid.querySelectorAll('[data-bundle-item]')),
        totalPages: Number(newGrid.dataset.pages || 1)
      };
    };

    const loadBundleFilterCatalog = async (bundleTag) => {
      if (!bundleTag || !bundleGrid) return getAvailableBundleFilters(bundleTag);
      if (bundleFilterCatalogByBundleTag[bundleTag]) return bundleFilterCatalogByBundleTag[bundleTag];
      if (bundleFilterCatalogPromises[bundleTag]) return bundleFilterCatalogPromises[bundleTag];

      bundleFilterCatalogPromises[bundleTag] = (async () => {
        const allItems = [...bundleItems];
        const totalPages = Number(bundleGrid.dataset.pages || 1);

        for (let page = 2; page <= totalPages; page += 1) {
          try {
            const result = await fetchBundlePageItems(page);
            allItems.push(...result.items);
          } catch (error) {
            console.error('[bundle-filter-catalog] erreur détaillée =', error);
            break;
          }
        }

        const filters = getAvailableBundleFilters(bundleTag, allItems);
        setBundleFilterCatalog(bundleTag, filters);
        return filters;
      })();

      return bundleFilterCatalogPromises[bundleTag];
    };

    const renderBundlePages = async (pageCount) => {
      if (!bundleGrid || isBundleLoading) return 0;

      isBundleLoading = true;
      clearBundleHasMoreCache();

      if (bundleLoadMoreButton) {
        bundleLoadMoreButton.hidden = false;
        bundleLoadMoreButton.disabled = true;
        bundleLoadMoreButton.textContent = 'Chargement...';
      }

      try {
        const fragment = document.createDocumentFragment();
        let lastTotalPages = Number(bundleGrid.dataset.pages || 1);

        for (let page = 1; page <= pageCount; page += 1) {
          const result = await fetchBundlePageItems(page);
          lastTotalPages = result.totalPages;

          result.items.forEach((item) => {
            fragment.appendChild(item);
          });
        }

        bundleGrid.innerHTML = '';
        bundleGrid.appendChild(fragment);
        bundleGrid.dataset.currentPage = String(pageCount);
        bundleGrid.dataset.pages = String(lastTotalPages);

        refreshBundleItemsCache();
        bindBundleItemEvents(bundleGrid);
        restoreSelectedVisualState();
        if (!bundleFilterCatalogByBundleTag[getCurrentBundleTag()]) {
          renderBundleFilters(getAvailableBundleFilters(getCurrentBundleTag()));
        }

        setLoadedPageForFilter(getCurrentFilterKey(), pageCount);
        clearBundleHasMoreCache();

        return filterBundleItems();
      } catch (error) {
        console.error('[bundle-render-pages] erreur détaillée =', error);

        if (bundleLoadMoreButton) {
          bundleLoadMoreButton.disabled = false;
          bundleLoadMoreButton.textContent = 'Charger plus';
        }

        return 0;
      } finally {
        isBundleLoading = false;
      }
    };

    const ensureMinimumItemsForFilter = async (minimum = MIN_VISIBLE_ITEMS_PER_FILTER) => {
      const filterKey = getCurrentFilterKey();
      let currentPage = getLoadedPageForFilter(filterKey);
      let totalPages = Number(bundleGrid?.dataset.pages || 1);
      let visibleCount = await renderBundlePages(currentPage);

      while (visibleCount < minimum && currentPage < totalPages) {
        currentPage += 1;
        visibleCount = await renderBundlePages(currentPage);
        totalPages = Number(bundleGrid?.dataset.pages || 1);
      }

      return visibleCount;
    };

    const loadMoreBundleItems = async () => {
      if (!bundleGrid) return;

      const filterKey = getCurrentFilterKey();
      let currentPage = getLoadedPageForFilter(filterKey);
      let totalPages = Number(bundleGrid.dataset.pages || 1);
      const visibleBefore = filterBundleItems();

      if (currentPage >= totalPages) {
        await updateLoadMoreVisibility();
        return;
      }

      setBundleUpdatingState(true);

      try {
        let visibleAfter = visibleBefore;

        while (visibleAfter <= visibleBefore && currentPage < totalPages) {
          currentPage += 1;
          visibleAfter = await renderBundlePages(currentPage);
          totalPages = Number(bundleGrid.dataset.pages || 1);
        }

        filterBundleItems();
        await updateLoadMoreVisibility();
      } finally {
        setBundleUpdatingState(false);
      }
    };

    const changeBundleFilter = async (filterValue) => {
      currentBundleFilter = filterValue || BEST_SELLERS_FILTER;
      clearBundleHasMoreCache();

      if (bundleFilters) {
        bundleFilters.querySelectorAll('[data-bundle-filter]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.bundleFilter === currentBundleFilter);
        });
      }

      setBundleUpdatingState(true);

      try {
        if (currentBundleFilter === BEST_SELLERS_FILTER) {
          await renderBestSellers();
        } else {
          const filterKey = getCurrentFilterKey();
          const alreadyLoadedPage = getLoadedPageForFilter(filterKey);

          await renderBundlePages(alreadyLoadedPage);
          await ensureMinimumItemsForFilter(MIN_VISIBLE_ITEMS_PER_FILTER);
        }
        filterBundleItems();
        await updateLoadMoreVisibility();
      } finally {
        setBundleUpdatingState(false);
      }
    };

    const openBundleModal = ({ preserveSelection = false, initialFilter = BEST_SELLERS_FILTER } = {}) => {
      if (!bundleModal || !selectedBundleCard) return;

      currentBundleConfig = {
        key: selectedBundleCard.dataset.bundleKey || '',
        tag: selectedBundleCard.dataset.bundleTag || '',
        qty: clampQty(selectedBundleCard.dataset.bundleQty || 0),
        variantId: selectedBundleCard.dataset.bundleVariantId || '',
        title: selectedBundleCard.dataset.bundleTitle || ''
      };

      currentBundleFilter = initialFilter;
      shuffleBestSellers();
      clearBundleHasMoreCache();
      if (!preserveSelection) clearBundleModalSelection();

      if (bundleTitle) {
        bundleTitle.textContent = `Choisissez vos ${currentBundleConfig.qty} affiches`;
      }

      if (bundleSearch) {
        bundleSearch.value = '';
      }

      renderBundleFilters();
      updateBundleModalUI();

      bundleModal.hidden = false;
      document.documentElement.classList.add('bundle-builder-open');
      document.body.classList.add('bundle-builder-open');
      window.requestAnimationFrame(updateBundleFilterScrollEnd);
      window.setTimeout(updateBundleFilterScrollEnd, 80);

      changeBundleFilter(initialFilter).finally(() => {
        loadBundleFilterCatalog(currentBundleConfig.tag).catch((error) => {
          console.error('[bundle-filter-catalog] chargement impossible =', error);
        });
      });
    };

    const hydratePersistentPackSelection = (context = readPersistentPackContext()) => {
      if (!context) return false;
      const contextCard = Array.from(bundleCards)
        .find((card) => card.dataset.bundleKey === context.key);
      if (!contextCard) return false;

      setSelectedBundle(contextCard);
      selectedBundleProducts = context.selectedPosters.map((product) => ({
        id: String(product.id),
        handle: product.handle || '',
        title: product.title || '',
        variantId: String(product.variantId || ''),
        image: product.image || ''
      }));

      return true;
    };

    const openPersistentFullSelector = () => {
      if (!bundleModal || !hydratePersistentPackSelection()) return;

      openBundleModal({ preserveSelection: true, initialFilter: 'all' });
    };

    const closeBundleModal = ({ syncPersistent = true } = {}) => {
      if (!bundleModal) return;

      if (syncPersistent) {
        syncPersistentPackSelections();
        updatePersistentPackContextUI();
      }

      closeBundlePreview();
      bundleModal.hidden = true;
      bundleModal.setAttribute('hidden', '');
      document.documentElement.classList.remove('bundle-builder-open');
      document.body.classList.remove('bundle-builder-open');
    };

    const toggleBundleProduct = (item) => {
      if (!item || !currentBundleConfig) return;

      const productId = item.dataset.productId;
      const productHandle = item.dataset.productHandle;
      const productTitle = item.dataset.productTitle;
      const productVariantId = item.dataset.productVariantId;
      const productImage = item.querySelector('.bundle-builder-card__image');
      const max = getCurrentBundleQty();

      const existingIndex = selectedBundleProducts.findIndex((product) => product.id === productId);

      if (existingIndex > -1) {
        selectedBundleProducts.splice(existingIndex, 1);
        item.classList.remove('is-selected');

        const button = item.querySelector('[data-bundle-select]');
        if (button) button.setAttribute('aria-pressed', 'false');

        updateBundleModalUI();
        syncPersistentPackSelections();
        return;
      }

      if (selectedBundleProducts.length >= max) {
        return;
      }

      selectedBundleProducts.push({
        id: productId,
        handle: productHandle,
        title: productTitle,
        variantId: productVariantId,
        image: productImage?.currentSrc || productImage?.src || ''
      });

      item.classList.add('is-selected');

      const button = item.querySelector('[data-bundle-select]');
      if (button) button.setAttribute('aria-pressed', 'true');

      updateBundleModalUI();
      syncPersistentPackSelections();
    };

    const getUploadLiftFileCount = () => {
      if (!bundlePersonalizationUpload) return 0;

      const requiredImages = getRequiredPackImages();
      const fileInput = bundlePersonalizationUpload.querySelector('input[type="file"]');
      if (fileInput?.files?.length >= requiredImages) return fileInput.files.length;

      const filepondItems = bundlePersonalizationUpload.querySelectorAll(
        '.filepond--item'
      );

      if (filepondItems.length) {
        const uniqueItems = new Set();

        filepondItems.forEach((item) => {
          const state = item.getAttribute('data-filepond-item-state') || '';

          if (!state || state.includes('complete')) {
            uniqueItems.add(item);
          }
        });

        if (uniqueItems.size >= requiredImages) return requiredImages;
      }

      const counterText = bundlePersonalizationUpload.querySelector('.cl-upload--counter')?.textContent || '';
      const counterMatch = counterText.match(/(\d+)\s*\/\s*(\d+)/);

      if (counterMatch && Number(counterMatch[1] || 0) >= requiredImages) return requiredImages;

      return fileInput?.files?.length || 0;
    };

    const setPackEditorFormat = (format = 'portrait', options = {}) => {
      const normalizedFormat = format === 'landscape' ? 'landscape' : 'portrait';
      const shouldResize = options.resize !== false;
      const shouldDraw = options.draw === true;
      const shouldPersist = options.persist !== false;

      if (shouldPersist) packEditorPreferredFormat = normalizedFormat;
      packEditorState.format = normalizedFormat;

      if (packEditor) packEditor.dataset.packEditorFormatCurrent = normalizedFormat;

      packEditorFormatButtons.forEach((button) => {
        const isActive = button.dataset.packEditorFormat === normalizedFormat;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (shouldResize) resizePackEditorCanvas();
      if (shouldDraw && packEditorState.image) drawPackEditorCanvas();
    };

    const resetPackEditorImageControls = (options = {}) => {
      const format = options.resetFormat ? 'portrait' : (options.format || packEditorState.format || packEditorPreferredFormat);

      packEditorState.zoom = 1;
      packEditorState.rotation = 0;
      packEditorState.offsetX = 0;
      packEditorState.offsetY = 0;

      if (packEditorZoom) packEditorZoom.value = 100;
      if (packEditorZoomValue) packEditorZoomValue.textContent = '100%';
      if (packEditorRotation) packEditorRotation.value = 0;
      if (packEditorRotationValue) packEditorRotationValue.textContent = '0°';
      setPackEditorFormat(format, { resize: true, draw: false, persist: false });
    };

    const invalidatePackEditorImageUpload = (index, options = {}) => {
      if (!Number.isInteger(index) || index < 0 || index >= getRequiredPackImages()) return;

      if (!Array.isArray(packEditorState.imgbbUrls)) packEditorState.imgbbUrls = [];
      packEditorState.imgbbUrls[index] = null;

      if (options.clearEdit === true && Array.isArray(packEditorState.edits)) {
        packEditorState.edits[index] = null;
      }

      packEditorState.completed = hasValidatedPackEditorEdits() && hasPackEditorImgBBUrls();
      if (!packEditorState.completed && packEditor) packEditor.classList.remove('is-complete');
      updatePackPersonalizationConfirmState();
    };

    const resetPackEditorCurrentImage = () => {
      if (!packEditorState.image) return;

      const index = packEditorState.currentIndex;
      if (Array.isArray(packEditorState.edits)) {
        packEditorState.edits[index] = null;
      }
      invalidatePackEditorImageUpload(index);

      packEditorState.completed = false;
      if (packEditor) packEditor.classList.remove('is-complete');
      resetPackEditorImageControls({ format: packEditorState.format });
      drawPackEditorCanvas();
      updatePackPersonalizationConfirmState();

      if (packEditorValidate) {
        packEditorValidate.disabled = false;
        packEditorValidate.textContent = `Valider l'image ${index + 1}`;
      }
      if (packEditorCurrent) packEditorCurrent.textContent = `Image ${index + 1} sur ${getRequiredPackImages()}`;
      setPackEditorStatus('Ajustez votre image, puis validez-la pour passer à la suivante.');
    };

    const setPackEditorStatus = (message) => {
      if (packEditorStatus) packEditorStatus.textContent = message;
    };

    const setPackEditorVisible = (visible) => {
      const shouldShow = Boolean(visible && isPackDrawerMode);

      if (packEditor) packEditor.hidden = !shouldShow;
      if (packEditorActions) packEditorActions.hidden = !shouldShow;
      if (mediaWrapper) mediaWrapper.classList.toggle('has-pack-editor-active', shouldShow);
      if (mediaColumn) mediaColumn.classList.toggle('has-pack-editor-active', shouldShow);

      if (shouldShow) {
        requestAnimationFrame(() => {
          forceMobileDrawerMediaWrapperCompact({ log: true });
          resizePackEditorCanvas();
          if (packEditorState.image) drawPackEditorCanvas();
          syncPackEditorValidateTop();
          scheduleMobileDrawerMediaWrapperCompact(120);
        });
      } else {
        syncPackEditorValidateTop();
      }
    };

    const showPackEditorPlaceholder = (visible) => {
      if (packEditorPlaceholder) packEditorPlaceholder.hidden = !visible;
    };

    const updatePackPersonalizationConfirmState = () => {
      if (!bundlePersonalizationConfirm) return;

      if (isCurrentPersonalizationBundle()) {
        bundlePersonalizationConfirm.disabled = !packEditorState.completed;
      } else {
        bundlePersonalizationConfirm.disabled = false;
      }

      if (packEditorValidate && isCurrentPersonalizationBundle() && packEditorState.completed) {
        packEditorValidate.disabled = false;
        packEditorValidate.textContent = 'Ajouter le pack personnalisation';
      }
    };

    const syncPackEditorValidateTop = () => {
      if (!packEditorValidateTop || !packEditorValidate) return;

      packEditorValidateTop.disabled = packEditorValidate.disabled;
      packEditorValidateTop.hidden = Boolean(packEditor?.hidden);
      packEditorValidateTop.textContent = packEditorState.completed ? 'Ajouter' : 'Valider';
    };

    if (packEditorValidateTop && packEditorValidate) {
      new MutationObserver(syncPackEditorValidateTop).observe(packEditorValidate, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });

      packEditorValidateTop.addEventListener('click', () => {
        packEditorValidate.click();
      });

      syncPackEditorValidateTop();
    }

    const closePackEditorDrawer = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!isPackDrawerMode) return;

      try {
        window.parent?.postMessage({ type: 'frizi-pack-close-drawer' }, '*');
        window.parent?.postMessage({ type: 'frizi-pack-drawer-close' }, '*');
      } catch (error) {
        console.warn('[pack-editor] fermeture drawer postMessage impossible', error);
      }

      try {
        const parentDocument = window.parent?.document;
        const parentDrawer = parentDocument?.querySelector('[data-pack-personalization-drawer]');
        if (parentDrawer) parentDrawer.hidden = true;
        parentDocument?.documentElement?.classList.remove('has-pack-personalization-drawer-open');
        parentDocument?.body?.classList.remove('has-pack-personalization-drawer-open');
      } catch (error) {
        debugPackEditor('fermeture drawer fallback indisponible', error);
      }

      if (window.parent === window && window.history.length > 1) {
        window.history.back();
      }
    };

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-pack-drawer-close], [data-pack-editor-cancel-top], .pack-editor__cancel, .pack-editor__cancel-top');
      if (closeButton && (!sectionEl || sectionEl.contains(closeButton))) {
        closePackEditorDrawer(event);
        return;
      }

      const resetButton = event.target.closest('[data-pack-editor-reset], .pack-editor__reset, .pack-editor__reset-top');
      if (!resetButton || (sectionEl && !sectionEl.contains(resetButton))) return;
      if (resetButton.disabled || resetButton.getAttribute('aria-disabled') === 'true' || !packEditorState.image) return;

      event.preventDefault();
      event.stopPropagation();
      resetPackEditorCurrentImage();
    });

    const notifyParentPackAddedToCart = () => {
      if (!isPackDrawerMode || window.parent === window) return false;

      try {
        window.parent.postMessage({ type: 'frizi-pack-added-to-cart' }, window.location.origin);
        return true;
      } catch (error) {
        console.warn('[pack-editor] notification ajout panier parent impossible', error);
        return false;
      }
    };

    const redirectPackFullpageAfterCart = () => {
      if (!isPackDirectFullpageMode) return false;

      let returnUrl = '/';

      try {
        returnUrl = sessionStorage.getItem(PACK_RETURN_STORAGE_KEY) || returnUrl;
      } catch (error) {
        console.warn('[pack-editor] URL retour pack indisponible', error);
      }

      const url = new URL(returnUrl, window.location.origin);
      url.searchParams.set('pack_cart_open', '1');
      window.location.href = `${url.pathname}${url.search}${url.hash}`;
      return true;
    };

    const getPackEditorSignature = (sources) =>
      sources
        .map((source) => `${source.type || 'source'}:${source.name || 'image'}:${source.size || 0}:${source.lastModified || 0}:${source.url || ''}`)
        .join('|');

    const summarizePackSources = (sources) =>
      sources.map((source, index) => ({
        index: index + 1,
        type: source.type || (source.file ? 'file' : 'url'),
        name: source.name || '',
        size: source.size || source.file?.size || 0,
        value: source.file
          ? `${source.file.name || 'file'}:${source.file.size || 0}`
          : `${source.url || ''}`.slice(0, 120)
      }));

    const clonePackSource = (source) => {
      if (!source) return null;

      return {
        file: source.file || null,
        url: source.url || '',
        type: source.type || (source.file ? 'file' : 'url'),
        name: source.name || source.file?.name || '',
        size: source.size || source.file?.size || 0,
        lastModified: source.lastModified || source.file?.lastModified || 0
      };
    };

    const pushUniquePackSource = (sources, source) => {
      if (!source || sources.length >= getRequiredPackImages()) return;

      const key = source.file
        ? `file:${source.file.name || ''}:${source.file.size || 0}:${source.file.lastModified || 0}`
        : `url:${source.url || ''}`;

      if (!key || key === 'url:' || sources.some((item) => {
        const itemKey = item.file
          ? `file:${item.file.name || ''}:${item.file.size || 0}:${item.file.lastModified || 0}`
          : `url:${item.url || ''}`;

        return itemKey === key;
      })) {
        return;
      }

      sources.push(source);
    };

    const getPackEditorFileKey = (file) => (
      file ? `${file.name || ''}:${file.size || 0}:${file.lastModified || 0}` : ''
    );

    const getPackUploadItemState = (item) => (
      (item?.getAttribute('data-filepond-item-state') || '').toLowerCase()
    );

    const isRejectedPackUploadState = (state = '') => (
      /error|invalid|fail|abort|remove|revert/.test(state)
    );

    const cleanupPackEditorUploadSlot = (index) => {
      if (!Number.isInteger(index) || index < 0 || index >= getRequiredPackImages()) return false;

      const cachedSource = packEditorOriginalFiles[index];
      const rejectedFile = cachedSource?.file || null;
      const rejectedKey = getPackEditorFileKey(rejectedFile);

      if (rejectedKey) packEditorRejectedFileKeys.add(rejectedKey);
      if (index < packEditorOriginalFiles.length) packEditorOriginalFiles.splice(index, 1);
      packEditorState.sourceSignature = '';

      if (packEditorState.currentIndex === index && !packEditorState.completed) {
        packEditorState.image = null;
        packEditorState.currentSource = null;
        if (packEditorCtx && packEditorCanvas) {
          packEditorCtx.clearRect(0, 0, packEditorCanvas.width, packEditorCanvas.height);
        }

        if (packEditor) packEditor.classList.remove('has-image', 'is-complete');
        showPackEditorPlaceholder(true);
        setPackEditorStatus('Image refusée par Upload Lift. Supprimez-la puis importez une nouvelle image valide.');
      }

      updatePackPersonalizationConfirmState();
      return true;
    };

    const cleanupRejectedPackUploadItems = () => {
      if (!bundlePersonalizationUpload) return false;

      let didClean = false;
      bundlePersonalizationUpload.querySelectorAll('.filepond--item').forEach((item, index) => {
        if (item.dataset.packEditorRejectedCleaned === 'true') return;

        const state = getPackUploadItemState(item);
        if (!isRejectedPackUploadState(state)) return;

        item.dataset.packEditorRejectedCleaned = 'true';
        didClean = cleanupPackEditorUploadSlot(index) || didClean;
      });

      return didClean;
    };

    const normalizePackEditorFileSources = (files) =>
      Array.from(files || [])
        .filter((file) => file?.type?.startsWith('image/') && !packEditorRejectedFileKeys.has(getPackEditorFileKey(file)))
        .slice(0, getRequiredPackImages())
        .map((file, index) => ({
          file,
          type: 'file',
          name: file.name || `image-${index + 1}.jpg`,
          size: file.size || 0,
          lastModified: file.lastModified || 0
        }));

    const bindPackUploadFileInputs = () => {
      if (!bundlePersonalizationUpload) return;

      bundlePersonalizationUpload.querySelectorAll('input[type="file"]').forEach((input) => {
        if (input.dataset.packEditorFileBound === 'true') return;
        input.dataset.packEditorFileBound = 'true';

        input.addEventListener('change', () => {
          cleanupRejectedPackUploadItems();

          const files = normalizePackEditorFileSources(input.files);
          if (files.length >= getRequiredPackImages()) {
            packEditorOriginalFiles = files;
          }

          schedulePackEditorUploadSync(80);
          schedulePackEditorUploadSync(260);
        });
      });
    };

    const getPackUploadUrlSources = () => {
      if (!bundlePersonalizationUpload) return [];

      const urls = [];
      const pushUrl = (value, name = '') => {
        const rawValue = (value || '').trim();
        const matches = Array.from(rawValue.matchAll(/(https?:\/\/[^\s"'<>\\]+|blob:[^\s"'<>\\]+|data:image\/[^\s"'<>\\]+)/gi));
        const candidates = matches.length ? matches.map((match) => match[1]) : [rawValue];

        candidates.forEach((url) => {
          if (urls.length >= getRequiredPackImages()) return;
          if (!url) return;
          if (!/^(https?:|blob:|data:image\/)/i.test(url)) return;
          if (urls.some((item) => item.url === url)) return;

          urls.push({
            url,
            type: url.startsWith('data:image/') ? 'dataUrl' : url.startsWith('blob:') ? 'blobUrl' : 'url',
            name: name || `image-${urls.length + 1}.jpg`,
            size: 0
          });
        });
      };

      bundlePersonalizationUpload.querySelectorAll('input[type="hidden"], input:not([type]), textarea').forEach((input) => {
        pushUrl(input.value, input.name || input.getAttribute('data-name') || '');
      });

      bundlePersonalizationUpload.querySelectorAll('a[href]').forEach((link) => {
        pushUrl(link.href, link.textContent?.trim() || link.getAttribute('download') || '');
      });

      return urls.slice(0, getRequiredPackImages());
    };

    const getPackUploadFileSources = () => {
      if (!bundlePersonalizationUpload) return [];

      const primaryFileInput = bundlePersonalizationUpload.querySelector('input[type="file"]');
      if (primaryFileInput?.files?.length >= getRequiredPackImages()) {
        return normalizePackEditorFileSources(primaryFileInput.files);
      }

      const sources = [];
      bundlePersonalizationUpload.querySelectorAll('input[type="file"]').forEach((input) => {
        normalizePackEditorFileSources(input.files).forEach((source) => pushUniquePackSource(sources, source));
      });

      return sources.slice(0, getRequiredPackImages());
    };

    const getPackUploadPreviewSources = () => {
      if (!bundlePersonalizationUpload) return [];

      const sources = [];
      const pushPreviewUrl = (url, name = '') => {
        if (!url) return;

        pushUniquePackSource(sources, {
          url,
          type: url.startsWith('data:image/') ? 'canvas' : url.startsWith('blob:') ? 'blob' : 'img',
          name: name || `image-${sources.length + 1}.jpg`,
          size: 0
        });
      };

      const extractBackgroundUrl = (element) => {
        const value = element?.style?.backgroundImage || '';
        const match = value.match(/url\(["']?(.+?)["']?\)/i);
        return match ? match[1] : '';
      };

      bundlePersonalizationUpload.querySelectorAll('.filepond--item').forEach((item, index) => {
        if (sources.length >= getRequiredPackImages()) return;

        const previewImage = item.querySelector('.filepond--image-preview img, .filepond--image-preview-wrapper img, img');
        if (previewImage?.src) {
          pushPreviewUrl(previewImage.src, previewImage.alt || `image-${index + 1}.jpg`);
          return;
        }

        const backgroundNode = item.querySelector('.filepond--image-preview, .filepond--image-preview-wrapper');
        const backgroundUrl = extractBackgroundUrl(backgroundNode);
        if (backgroundUrl) {
          pushPreviewUrl(backgroundUrl, `image-${index + 1}.jpg`);
          return;
        }

        const canvas = item.querySelector('.filepond--image-preview canvas, canvas');
        if (!canvas) return;

        try {
          pushPreviewUrl(canvas.toDataURL('image/jpeg', 0.92), `image-${index + 1}.jpg`);
        } catch (error) {
          console.warn('[pack-editor] Preview FilePond item illisible', error);
        }
      });

      if (sources.length >= getRequiredPackImages()) return sources.slice(0, getRequiredPackImages());

      bundlePersonalizationUpload.querySelectorAll('.filepond--image-preview img, .filepond--image-preview-wrapper img, img').forEach((img, index) => {
        if (sources.length >= getRequiredPackImages()) return;
        if (!img.src) return;

        pushPreviewUrl(img.src, img.alt || `image-${index + 1}.jpg`);
      });

      if (sources.length >= getRequiredPackImages()) return sources.slice(0, getRequiredPackImages());

      bundlePersonalizationUpload.querySelectorAll('.filepond--image-preview canvas, canvas').forEach((canvas, index) => {
        if (sources.length >= getRequiredPackImages()) return;

        try {
          pushPreviewUrl(canvas.toDataURL('image/jpeg', 0.92), `image-${index + 1}.jpg`);
        } catch (error) {
          console.warn('[pack-editor] Preview FilePond illisible', error);
        }
      });

      return sources.slice(0, getRequiredPackImages());
    };

    const getPackImgBBPreviewSources = () => {
      if (!bundlePersonalizationUpload) return [];

      const sources = [];
      const pushPreviewUrl = (url, name = '') => {
        if (!url) return;

        pushUniquePackSource(sources, {
          url,
          type: url.startsWith('data:image/') ? 'canvas' : url.startsWith('blob:') ? 'blob' : 'img',
          name: name || `image-${sources.length + 1}.jpg`,
          size: 0
        });
      };

      const extractBackgroundUrl = (element) => {
        const value = element?.style?.backgroundImage || '';
        const match = value.match(/url\(["']?(.+?)["']?\)/i);
        return match ? match[1] : '';
      };

      bundlePersonalizationUpload.querySelectorAll('.filepond--item').forEach((item, index) => {
        if (sources.length >= getRequiredPackImages()) return;
        const state = getPackUploadItemState(item);
        if (isRejectedPackUploadState(state)) return;

        const previewImage = item.querySelector('.filepond--image-preview img, .filepond--image-preview-wrapper img, img');
        if (previewImage?.src) {
          pushPreviewUrl(previewImage.src, previewImage.alt || `image-${index + 1}.jpg`);
          return;
        }

        const backgroundNode = item.querySelector('.filepond--image-preview, .filepond--image-preview-wrapper');
        const backgroundUrl = extractBackgroundUrl(backgroundNode);
        if (backgroundUrl) {
          pushPreviewUrl(backgroundUrl, `image-${index + 1}.jpg`);
          return;
        }

        const canvas = item.querySelector('.filepond--image-preview canvas, canvas');
        if (!canvas) return;

        try {
          pushPreviewUrl(canvas.toDataURL('image/jpeg', 0.92), `image-${index + 1}.jpg`);
        } catch (error) {
          console.warn('[pack imgbb debug] preview canvas fallback unavailable', index + 1, error);
        }
      });

      return sources.slice(0, getRequiredPackImages());
    };

    const getPackUploadItemSource = (item, index) => {
      if (!item) return null;

      const pushSourceUrl = (url, name = '') => {
        if (!url) return null;

        return {
          url,
          type: url.startsWith('data:image/') ? 'canvas' : url.startsWith('blob:') ? 'blob' : 'img',
          name: name || `image-${index + 1}.jpg`,
          size: 0
        };
      };

      const extractBackgroundUrl = (element) => {
        const value = element?.style?.backgroundImage || '';
        const match = value.match(/url\(["']?(.+?)["']?\)/i);
        return match ? match[1] : '';
      };

      const previewImage = item.querySelector('.filepond--image-preview img, .filepond--image-preview-wrapper img, img');
      if (previewImage?.src) {
        return pushSourceUrl(previewImage.src, previewImage.alt || `image-${index + 1}.jpg`);
      }

      const backgroundNode = item.querySelector('.filepond--image-preview, .filepond--image-preview-wrapper');
      const backgroundUrl = extractBackgroundUrl(backgroundNode);
      if (backgroundUrl) {
        return pushSourceUrl(backgroundUrl, `image-${index + 1}.jpg`);
      }

      const canvas = item.querySelector('.filepond--image-preview canvas, canvas');
      if (!canvas) return null;

      try {
        return pushSourceUrl(canvas.toDataURL('image/jpeg', 0.92), `image-${index + 1}.jpg`);
      } catch (error) {
        console.warn('[pack order stable] item canvas source unavailable', index + 1, error);
        return null;
      }
    };

    const isAcceptedPackUploadItem = (item) => {
      const state = getPackUploadItemState(item);
      if (isRejectedPackUploadState(state)) return false;
      if (!state) return true;

      return /complete|processed|loaded|idle/.test(state);
    };

    const buildStablePackSources = () => {
      if (!bundlePersonalizationUpload) return [];

      const filepondItems = Array.from(bundlePersonalizationUpload.querySelectorAll('.filepond--item'));
      if (filepondItems.length) {
        const sources = [];

        filepondItems.forEach((item, index) => {
          if (sources.length >= getRequiredPackImages()) return;
          if (!isAcceptedPackUploadItem(item)) return;

          const source = getPackUploadItemSource(item, sources.length);
          if (source) sources.push(source);
        });

        console.info('[pack order stable] accepted sources', summarizePackSources(sources));
        return sources.length === getRequiredPackImages() ? sources : [];
      }

      const urlSources = getPackUploadUrlSources();
      if (urlSources.length === getRequiredPackImages()) {
        console.info('[pack order stable] accepted sources', summarizePackSources(urlSources));
        return urlSources;
      }

      return [];
    };

    const getPackUploadSources = () => {
      if (!bundlePersonalizationUpload) return [];

      if (packEditorOriginalFiles.length >= getRequiredPackImages()) {
        return packEditorOriginalFiles.slice(0, getRequiredPackImages());
      }

      const fileSources = getPackUploadFileSources();
      if (fileSources.length >= getRequiredPackImages()) {
        packEditorOriginalFiles = fileSources;
        return fileSources;
      }

      const urlSources = getPackUploadUrlSources();
      if (urlSources.length >= getRequiredPackImages()) {
        return urlSources;
      }

      return getPackUploadPreviewSources();
    };

    let packMobileGapLogged = false;

    const isPackDrawerMobileViewport = () => (
      isPackDrawerMode && window.matchMedia('(max-width: 749px)').matches
    );

    const forceMobileDrawerMediaWrapperCompact = (options = {}) => {
      if (!isPackDrawerMobileViewport()) return;

      const wrapper = mediaWrapper || document.querySelector('.main-product__media-wrapper.has-pack-editor-active');
      if (!wrapper) return;

      wrapper.style.height = 'auto';
      wrapper.style.minHeight = '0';
      wrapper.style.display = 'block';
      wrapper.style.placeItems = 'initial';

      if (options.log && !packMobileGapLogged) {
        packMobileGapLogged = true;
        console.info('[pack mobile gap]', {
          innerWidth: window.innerWidth,
          wrapper: wrapper.getBoundingClientRect(),
          wrapperStyle: wrapper.getAttribute('style'),
          classes: wrapper.className
        });
      }
    };

    const scheduleMobileDrawerMediaWrapperCompact = (delay = 0, options = {}) => {
      if (!isPackDrawerMode) return;
      window.setTimeout(() => forceMobileDrawerMediaWrapperCompact(options), delay);
    };

    const resizePackEditorCanvas = () => {
      if (!packEditorStage || !packEditorCanvas || !packEditorCtx) return;

      forceMobileDrawerMediaWrapperCompact();

      if (mediaWrapper) {
        const mediaRect = mediaWrapper.getBoundingClientRect();
        const isMobileEditor = window.matchMedia('(max-width: 749px)').matches;
        const isDrawerDesktop = isPackDrawerMode && !window.matchMedia('(max-width: 989px)').matches;
        const isDrawerMobile = isPackDrawerMode && !isDrawerDesktop;
        let stageWidth;
        let stageHeight;

        if (isDrawerDesktop) {
          const uploadColumnWidth = 360;
          const availableWidth = Math.max(360, window.innerWidth - uploadColumnWidth - 96);
          const availableHeight = Math.max(420, window.innerHeight - 174);
          const portraitHeight = Math.min(660, availableWidth, availableHeight);
          const portraitWidth = portraitHeight * 3 / 4;
          stageWidth = packEditorState.format === 'landscape' ? portraitHeight : portraitWidth;
          stageHeight = packEditorState.format === 'landscape' ? portraitWidth : portraitHeight;
        } else if (isDrawerMobile) {
          const availableWidth = Math.max(260, window.innerWidth - 24);
          const availableHeight = Math.max(300, window.innerHeight - 250);
          const landscapeWidth = Math.min(480, availableWidth, availableHeight * 4 / 3);
          const landscapeHeight = landscapeWidth * 3 / 4;
          stageWidth = packEditorState.format === 'landscape' ? landscapeWidth : landscapeHeight;
          stageHeight = packEditorState.format === 'landscape' ? landscapeHeight : landscapeWidth;
        } else {
          const stageW = mediaRect.width;
          const stageH = mediaRect.height || stageW;
          const maxW = isMobileEditor ? Math.min(Math.max(stageW - 16, 300), 460) : stageW * 0.72;
          const maxH = isMobileEditor ? Math.max(window.innerHeight * 0.56, 390) : stageH * 0.72;
          const portraitHeight = Math.min(maxW, maxH);
          const portraitWidth = portraitHeight * 3 / 4;
          stageWidth = packEditorState.format === 'landscape' ? portraitHeight : portraitWidth;
          stageHeight = packEditorState.format === 'landscape' ? portraitWidth : portraitHeight;
        }

        packEditorStage.style.width = `${Math.round(stageWidth)}px`;
        packEditorStage.style.height = `${Math.round(stageHeight)}px`;

      }

      const rect = packEditorStage.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const isMobileEditor = window.matchMedia('(max-width: 749px)').matches;
      const isDrawerMobileViewport = isPackDrawerMode && isMobileEditor;
      const measuredStageWidth = `${Math.round(rect.width)}px`;
      const measuredStageHeight = `${Math.round(rect.height)}px`;
      const measuredActionWidth = isDrawerMobileViewport
        ? measuredStageWidth
        : (isMobileEditor && mediaWrapper
          ? `${Math.round(Math.min(Math.max(mediaWrapper.getBoundingClientRect().width, rect.width), 480))}px`
          : measuredStageWidth);

      if (packEditor) {
        packEditor.style.setProperty('--pack-editor-stage-width', measuredStageWidth);
        packEditor.style.setProperty('--pack-editor-stage-height', measuredStageHeight);
        packEditor.style.setProperty('--pack-editor-action-width', measuredActionWidth);
      }

      if (isPackDrawerMode) {
        const isDrawerDesktopViewport = !window.matchMedia('(max-width: 989px)').matches;

        [document.documentElement, document.body].forEach((element) => {
          if (!element) return;
          element.style.setProperty('--pack-editor-stage-width', measuredStageWidth);
        });

        if (isDrawerDesktopViewport) {
          const workbench = packEditorStage.closest('.pack-editor__workbench');
          const wrapper = mediaWrapper || document.querySelector('.main-product__media-wrapper');
          const viewportCenter = window.innerWidth / 2;
          const stageCenter = rect.left + rect.width / 2;
          const delta = viewportCenter - stageCenter;
          const currentCorrection = Number.parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--pack-editor-center-correction')
          ) || 0;
          const nextCorrection = Math.round((currentCorrection + delta) * 100) / 100;
          const uploadWidth = 300;
          const uploadGap = Math.min(120, Math.max(72, window.innerWidth * 0.05));
          const correctedStageRight = rect.right + delta;
          const uploadLeft = Math.round(
            Math.max(24, Math.min(correctedStageRight + uploadGap, window.innerWidth - uploadWidth - 24))
          );
          const rectSnapshot = (targetRect) => targetRect ? {
            left: Math.round(targetRect.left),
            right: Math.round(targetRect.right),
            width: Math.round(targetRect.width),
            center: Math.round(targetRect.left + targetRect.width / 2)
          } : null;

          [document.documentElement, document.body].forEach((element) => {
            if (!element) return;
            element.style.setProperty('--pack-editor-center-correction', `${nextCorrection}px`);
            element.style.setProperty('--pack-editor-upload-left', `${uploadLeft}px`);
          });

          console.info('[pack-editor center]', {
            before: {
              viewport: window.innerWidth,
              viewportCenter: Math.round(viewportCenter),
              stageCenter: Math.round(stageCenter),
              delta: Math.round(delta),
              currentCorrection,
              nextCorrection,
              stage: rectSnapshot(rect),
              workbench: rectSnapshot(workbench?.getBoundingClientRect()),
              wrapper: rectSnapshot(wrapper?.getBoundingClientRect())
            },
            after: {
              stageCenter: Math.round(stageCenter + delta),
              viewportCenter: Math.round(viewportCenter),
              uploadLeft
            }
          });
        }
      }

      [packEditorCurrent, packEditorControls, packEditorValidate].forEach((element) => {
        if (!element) return;
        element.style.width = measuredActionWidth;
        element.style.maxWidth = measuredActionWidth;
      });

      forceMobileDrawerMediaWrapperCompact();

      const dpr = window.devicePixelRatio || 1;
      packEditorCanvas.width = Math.round(rect.width * dpr);
      packEditorCanvas.height = Math.round(rect.height * dpr);
      packEditorCanvas.style.width = `${rect.width}px`;
      packEditorCanvas.style.height = `${rect.height}px`;
      packEditorCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    const drawPackEditorCanvas = () => {
      if (!packEditorStage || !packEditorCanvas || !packEditorCtx || !packEditorState.image) return;

      const rect = packEditorStage.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;

      packEditorCtx.clearRect(0, 0, width, height);
      packEditorCtx.save();
      packEditorCtx.imageSmoothingEnabled = true;
      packEditorCtx.imageSmoothingQuality = 'high';
      packEditorCtx.translate(width / 2 + packEditorState.offsetX, height / 2 + packEditorState.offsetY);
      packEditorCtx.rotate((packEditorState.rotation * Math.PI) / 180);
      packEditorCtx.scale(packEditorState.zoom, packEditorState.zoom);

      const imageWidth = packEditorState.image.naturalWidth || packEditorState.image.width;
      const imageHeight = packEditorState.image.naturalHeight || packEditorState.image.height;
      const baseSize = Math.min(width, height);
      const imageBaseSize = Math.max(imageWidth, imageHeight);
      const scale = baseSize / imageBaseSize;
      const drawWidth = imageWidth * scale;
      const drawHeight = imageHeight * scale;

      packEditorCtx.drawImage(packEditorState.image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
      packEditorCtx.restore();
    };

    const loadPackEditorImageFromUrl = (url, options = {}) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        const allowCrossOrigin = options.crossOrigin !== false;

        if (allowCrossOrigin && !url.startsWith('data:') && !url.startsWith('blob:')) {
          image.crossOrigin = 'anonymous';
        }

        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = url;
      });

    const loadPackEditorImageSafely = async (sourceUrl) => {
      try {
        return await loadPackEditorImageFromUrl(sourceUrl);
      } catch (error) {
        if (!/^https?:/i.test(sourceUrl)) throw error;

        debugPackEditor('image load retry without crossOrigin', sourceUrl.slice(0, 120), error);
        return loadPackEditorImageFromUrl(sourceUrl, { crossOrigin: false });
      }
    };

    const getPackEditorSourceUrl = (source) =>
      new Promise((resolve, reject) => {
        if (source.url) {
          resolve(source.url);
          return;
        }

        if (!source.file) {
          reject(new Error('Source image introuvable'));
          return;
        }

        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(source.file);
      });

    const loadPackEditorImage = async (index) => {
      const source = packEditorState.sources[index];
      if (!source || !packEditor || !packEditorCanvas || !packEditorCtx) return;

      packEditorState.currentIndex = index;
      packEditorState.currentSource = clonePackSource(source);
      resetPackEditorImageControls();

      if (packEditorCurrent) packEditorCurrent.textContent = `Image ${index + 1} sur ${getRequiredPackImages()}`;
      if (packEditorValidate) {
        packEditorValidate.disabled = true;
        packEditorValidate.textContent = `Chargement image ${index + 1}...`;
      }

      try {
        const sourceUrl = await getPackEditorSourceUrl(source);
        debugPackEditor('load image start', {
          index: index + 1,
          source: summarizePackSources([source])[0],
          sourceUrl: sourceUrl.slice(0, 120)
        });
        packEditorState.image = await loadPackEditorImageSafely(sourceUrl);
        debugPackEditor('load image success', {
          index: index + 1,
          width: packEditorState.image.naturalWidth || packEditorState.image.width,
          height: packEditorState.image.naturalHeight || packEditorState.image.height
        });
        console.info('[pack order debug] editor current index/source', index + 1, summarizePackSources(packEditorState.currentSource ? [packEditorState.currentSource] : [])[0] || null);
        if (packEditor) packEditor.classList.add('has-image');
        showPackEditorPlaceholder(false);
        resizePackEditorCanvas();
        drawPackEditorCanvas();

        if (packEditorValidate) {
          packEditorValidate.disabled = false;
          packEditorValidate.textContent = `Valider l'image ${index + 1}`;
        }

        setPackEditorStatus('Ajustez votre image, puis validez-la pour passer à la suivante.');
      } catch (error) {
        console.error('[pack-editor] Chargement image impossible', {
          index: index + 1,
          source: summarizePackSources([source])[0],
          error
        });
        packEditorState.image = null;
        if (packEditor) packEditor.classList.remove('has-image');
        setPackEditorStatus("Impossible de charger cette image. Supprimez-la puis importez-la à nouveau.");
      }
    };

    const canvasToJpegBlob = (canvas) =>
      new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9);
      });

    const capturePackEditorCanvasPreview = () => {
      if (!packEditorCanvas) return '';

      try {
        return packEditorCanvas.toDataURL('image/jpeg', 0.92);
      } catch (error) {
        console.warn('[pack order debug] canvas preview snapshot failed', error);
        return '';
      }
    };

    const hasValidatedPackEditorEdits = () => (
      Array.isArray(packEditorState.edits) &&
      packEditorState.edits.slice(0, getRequiredPackImages()).filter((edit) => edit?.validated).length === getRequiredPackImages()
    );

    const hasAnyValidatedPackEditorEdit = () => (
      Array.isArray(packEditorState.edits) &&
      packEditorState.edits.some((edit) => edit?.validated)
    );

    const hasPackEditorImgBBUrls = () => (
      Array.isArray(packEditorState.imgbbUrls) &&
      packEditorState.imgbbUrls.length >= getRequiredPackImages() &&
      packEditorState.imgbbUrls.slice(0, getRequiredPackImages()).every(Boolean)
    );

    const renderPackSourceToBlob = async (source, edit, index) => {
      const sourceUrl = await getPackEditorSourceUrl(source);
      const image = await loadPackEditorImageSafely(sourceUrl);
      const dpr = window.devicePixelRatio || 1;
      const displayWidth = Number(edit.canvasDisplayWidth) || packEditorStage?.getBoundingClientRect().width || 1;
      const displayHeight = Number(edit.canvasDisplayHeight) || packEditorStage?.getBoundingClientRect().height || 1;
      const exportCanvas = document.createElement('canvas');
      const exportContext = exportCanvas.getContext('2d');

      if (!exportContext) {
        throw new Error(`Contexte canvas indisponible pour l'image ${index + 1}`);
      }

      exportCanvas.width = Math.max(1, Math.round(displayWidth * dpr));
      exportCanvas.height = Math.max(1, Math.round(displayHeight * dpr));
      edit.canvasExportWidth = exportCanvas.width;
      edit.canvasExportHeight = exportCanvas.height;
      exportContext.setTransform(dpr, 0, 0, dpr, 0, 0);
      exportContext.clearRect(0, 0, displayWidth, displayHeight);
      exportContext.save();
      exportContext.imageSmoothingEnabled = true;
      exportContext.imageSmoothingQuality = 'high';
      exportContext.translate(displayWidth / 2 + Number(edit.offsetX || 0), displayHeight / 2 + Number(edit.offsetY || 0));
      exportContext.rotate((Number(edit.rotation || 0) * Math.PI) / 180);
      exportContext.scale(Number(edit.zoom || 1), Number(edit.zoom || 1));

      const imageWidth = image.naturalWidth || image.width;
      const imageHeight = image.naturalHeight || image.height;
      edit.imageNaturalWidth = imageWidth || null;
      edit.imageNaturalHeight = imageHeight || null;
      const baseSize = Math.min(displayWidth, displayHeight);
      const imageBaseSize = Math.max(imageWidth, imageHeight);
      const scale = baseSize / imageBaseSize;
      const drawWidth = imageWidth * scale;
      const drawHeight = imageHeight * scale;

      exportContext.drawImage(image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
      exportContext.restore();

      const blob = await canvasToJpegBlob(exportCanvas);

      if (!blob) {
        throw new Error(`Export canvas impossible pour l'image ${index + 1}`);
      }

      return blob;
    };

    const renderPackEditedImageToBlob = async (index) => {
      const edit = packEditorState.edits[index];
      const source = edit?.sourceSnapshot || packEditorState.sources[index];

      console.info('[pack imgbb debug] source', index + 1, summarizePackSources(source ? [source] : [])[0] || null);
      console.info('[pack imgbb debug] edit', index + 1, edit ? {
        fileName: edit.fileName,
        format: edit.format,
        zoom: edit.zoom,
        rotation: edit.rotation,
        offsetX: edit.offsetX,
        offsetY: edit.offsetY,
        sourceSignature: edit.sourceSignature || '',
        hasCanvasPreview: Boolean(edit.canvasPreviewDataUrl),
        validated: edit.validated
      } : null);

      if (!source || !edit?.validated) {
        throw new Error(`Image ${index + 1} non validée`);
      }

      try {
        const blob = await renderPackSourceToBlob(source, edit, index);
        console.info('[pack imgbb debug] blob', index + 1, {
          size: blob.size,
          type: blob.type
        });
        return blob;
      } catch (error) {
        console.warn('[pack imgbb debug] primary render failed', index + 1, error);

        const fallbackSource = getPackImgBBPreviewSources()[index];
        const snapshotFallback = edit?.canvasPreviewDataUrl
          ? {
              url: edit.canvasPreviewDataUrl,
              type: 'canvas',
              name: edit.fileName || `image-${index + 1}.jpg`,
              size: 0
            }
          : null;
        const resolvedFallbackSource = snapshotFallback || fallbackSource;
        if (!resolvedFallbackSource) throw error;

        console.info('[pack imgbb debug] fallback source', index + 1, summarizePackSources([resolvedFallbackSource])[0]);
        const fallbackBlob = await renderPackSourceToBlob(resolvedFallbackSource, edit, index);
        console.info('[pack imgbb debug] blob fallback', index + 1, {
          size: fallbackBlob.size,
          type: fallbackBlob.type
        });
        return fallbackBlob;
      }
    };

    const uploadPackBlobToImgBB = async (blob, index) => {
      const formData = new FormData();
      formData.append('image', blob, `frizi-pack-image-${index + 1}.jpg`);

      console.info('[pack imgbb debug] fetch', index + 1, {
        size: blob?.size || 0,
        type: blob?.type || ''
      });
      const response = await fetch(`https://api.imgbb.com/1/upload?key=${PACK_IMGBB_KEY}`, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      console.info('[pack imgbb debug] response', index + 1, {
        ok: response.ok,
        success: data?.success,
        url: data?.data?.url || '',
        error: data?.error?.message || ''
      });

      if (!response.ok || !data?.success || !data?.data?.url) {
        throw new Error(data?.error?.message || `Upload ImgBB échoué pour l'image ${index + 1}`);
      }

      return data.data.url;
    };

    const uploadPackEditedImageToImgBB = async (index) => {
      if (packEditorState.imgbbUrls?.[index]) return packEditorState.imgbbUrls[index];

      console.info('[pack imgbb debug] start', index + 1);
      console.info('[pack imgbb upload image]', index + 1);
      console.info('[pack order debug] imgbb index/source', index + 1, summarizePackSources(packEditorState.edits[index]?.sourceSnapshot ? [packEditorState.edits[index].sourceSnapshot] : [])[0] || null);
      const blob = await renderPackEditedImageToBlob(index);
      const url = await uploadPackBlobToImgBB(blob, index);

      if (!Array.isArray(packEditorState.imgbbUrls)) packEditorState.imgbbUrls = [];
      packEditorState.imgbbUrls[index] = url;
      console.info('[pack imgbb uploaded]', index + 1, url);

      return url;
    };

    async function uploadPackEditedImagesToImgBB() {
      const requiredImages = getRequiredPackImages();
      if (!hasValidatedPackEditorEdits()) {
        throw new Error(`Les ${requiredImages} images du pack doivent être validées avant upload ImgBB.`);
      }

      console.info('[pack imgbb urls before cart]', packEditorState.imgbbUrls || []);

      for (let index = 0; index < requiredImages; index += 1) {
        if (!packEditorState.imgbbUrls?.[index]) {
          await uploadPackEditedImageToImgBB(index);
        }
      }

      const urls = (packEditorState.imgbbUrls || []).slice(0, requiredImages);
      console.info('[pack imgbb]', urls);
      console.info('[pack order debug] cart urls', urls);
      return urls;
    }

    const buildPackPhotoshopEditData = (urls, createdAt) => {
      if (!Array.isArray(urls) || urls.length !== getRequiredPackImages() || urls.some((url) => !url)) return [];

      return urls.map((url, index) => {
        const edit = packEditorState.edits[index] || {};
        const source = edit.sourceSnapshot || packEditorState.sources[index] || {};
        const displayWidth = Number(edit.canvasDisplayWidth || 0);
        const displayHeight = Number(edit.canvasDisplayHeight || 0);
        const dpr = window.devicePixelRatio || 1;

        return {
          format: edit.format || 'portrait',
          zoom: Number(edit.zoom || 1),
          rotation: Number(edit.rotation || 0),
          offsetX: Number(edit.offsetX || 0),
          offsetY: Number(edit.offsetY || 0),
          canvasDisplayWidth: displayWidth,
          canvasDisplayHeight: displayHeight,
          canvasExportWidth: Number(edit.canvasExportWidth || Math.max(1, Math.round(displayWidth * dpr))),
          canvasExportHeight: Number(edit.canvasExportHeight || Math.max(1, Math.round(displayHeight * dpr))),
          imageNaturalWidth: Number(edit.imageNaturalWidth || source.file?.width || 0) || null,
          imageNaturalHeight: Number(edit.imageNaturalHeight || source.file?.height || 0) || null,
          originalFileName: source.name || edit.fileName || `image-${index + 1}.jpg`,
          previewUrl: url,
          createdAt
        };
      });
    };

    const buildPackImgBBProperties = (urls) => {
      if (!Array.isArray(urls) || urls.length !== getRequiredPackImages() || urls.some((url) => !url)) return {};
      const createdAt = new Date().toISOString();
      const photoshopData = buildPackPhotoshopEditData(urls, createdAt);

      const images = urls.map((url, index) => {
        const edit = packEditorState.edits[index] || {};
        const source = edit.sourceSnapshot || packEditorState.sources[index] || {};

        return {
          index: index + 1,
          url,
          orientation: edit.format || 'portrait',
          zoom: Number(edit.zoom || 1),
          rotation: Number(edit.rotation || 0),
          offsetX: Number(edit.offsetX || 0),
          offsetY: Number(edit.offsetY || 0),
          canvasWidth: Number(edit.canvasDisplayWidth || 0),
          canvasHeight: Number(edit.canvasDisplayHeight || 0),
          canvasExportWidth: Number(edit.canvasExportWidth || 0),
          canvasExportHeight: Number(edit.canvasExportHeight || 0),
          imageNaturalWidth: Number(edit.imageNaturalWidth || 0) || null,
          imageNaturalHeight: Number(edit.imageNaturalHeight || 0) || null,
          sourceName: source.name || edit.fileName || `image-${index + 1}.jpg`
        };
      });

      console.info('[pack photoshop data]', photoshopData);

      const properties = {
        _frizi_pack_edit_data: JSON.stringify({
          type: 'frizi_pack_personalization',
          version: 1,
          createdAt,
          images
        })
      };

      urls.forEach((url, index) => {
        const position = index + 1;
        properties[`_pack_image_${position}`] = url;
        properties[`_image client print ${position}`] = url;
        properties[`_frizi_edit_data_${position}`] = JSON.stringify(photoshopData[index]);
      });

      return properties;
    };

    const resetPackEditorState = (options = {}) => {
      const preserveFormat = options.preserveFormat === true;
      const nextFormat = preserveFormat ? packEditorPreferredFormat : 'portrait';

      if (isPackDrawerMode && !preserveFormat) packEditorPreferredFormat = 'portrait';

      packEditorState = {
        sources: [],
        sourceSignature: '',
        currentIndex: 0,
        currentSource: null,
        image: null,
        edits: [],
        imgbbUrls: [],
        format: isPackDrawerMode ? nextFormat : packEditorPreferredFormat,
        zoom: 1,
        rotation: 0,
        offsetX: 0,
        offsetY: 0,
        isDragging: false,
        dragStartX: 0,
        dragStartY: 0,
        dragOffsetX: 0,
        dragOffsetY: 0,
        completed: false
      };

      if (packEditorCtx && packEditorCanvas) {
        packEditorCtx.clearRect(0, 0, packEditorCanvas.width, packEditorCanvas.height);
      }

      setPackEditorFormat(isPackDrawerMode ? nextFormat : packEditorPreferredFormat, { resize: true, draw: false, persist: false });
      if (packEditor) packEditor.classList.remove('has-image', 'is-complete');
      showPackEditorPlaceholder(true);
      if (packEditorCurrent) packEditorCurrent.textContent = `Image 0 sur ${getRequiredPackImages()}`;
      setPackEditorStatus(`Importez exactement ${getRequiredPackImages()} images pour lancer l’éditeur.`);
      if (packEditorValidate) {
        packEditorValidate.disabled = true;
        packEditorValidate.textContent = "Valider l'image 1";
      }

      setPackEditorVisible(sectionEl.dataset.packPurchaseMode === 'packs');
      updatePackPersonalizationConfirmState();
    };

    const syncPackEditorWithUploads = async () => {
      if (!isCurrentPersonalizationBundle()) return;

      cleanupRejectedPackUploadItems();

      const requiredImages = getRequiredPackImages();
      const sources = buildStablePackSources();
      const uploadedCount = sources.length;
      debugPackEditor('sync count', {
        uploadedCount,
        originalFiles: packEditorOriginalFiles.length
      });

      if (sources.length !== requiredImages) {
        packEditorUploadRetryCount = 0;
        resetPackEditorState({ preserveFormat: isPackDrawerMode && Boolean(packEditor && !packEditor.hidden) });
        return;
      }

      debugPackEditor('sync sources', {
        count: sources.length,
        sources: summarizePackSources(sources)
      });

      packEditorUploadRetryCount = 0;
      const signature = getPackEditorSignature(sources);
      if (signature === packEditorState.sourceSignature && packEditorState.sources.length === requiredImages) {
        return;
      }

      console.info('[pack order stable] rebuilding', summarizePackSources(sources));
      packEditorState.sources = sources;
      packEditorState.sourceSignature = signature;
      packEditorState.edits = new Array(requiredImages).fill(null);
      packEditorState.imgbbUrls = new Array(requiredImages).fill(null);
      packEditorState.completed = false;
      if (isPackDrawerMode) packEditorPreferredFormat = 'portrait';
      setPackEditorVisible(true);
      updatePackPersonalizationConfirmState();
      await loadPackEditorImage(0);
    };

    const schedulePackEditorUploadSync = (delay = 150) => {
      window.clearTimeout(packEditorUploadSyncTimer);
      packEditorUploadSyncTimer = window.setTimeout(() => {
        syncPackEditorWithUploads().catch((error) => console.error('[pack-editor] sync différé erreur =', error));
      }, delay);
    };

    const setPackUploadInlineStyle = (element, property, value) => {
      if (!element || element.style[property] === value) return;
      element.style[property] = value;
    };

    const forceMobileUploadWidth = () => {
      if (!document.body?.classList.contains('frizi-pack-drawer-mode')) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const width = '280px';

      document.querySelectorAll(
        '.bundle-personalization__upload, .frizi-upload-area, .cl-upload--wrapper, .filepond--root.cl-upload-area, .filepond--drop-label'
      ).forEach((element) => {
        setPackUploadInlineStyle(element, 'width', width);
        setPackUploadInlineStyle(element, 'maxWidth', width);
        setPackUploadInlineStyle(element, 'minWidth', width);
        setPackUploadInlineStyle(element, 'marginLeft', 'auto');
        setPackUploadInlineStyle(element, 'marginRight', 'auto');
        setPackUploadInlineStyle(element, 'boxSizing', 'border-box');
      });

      document.querySelectorAll('.filepond--drop-label label').forEach((label) => {
        setPackUploadInlineStyle(label, 'width', '100%');
        setPackUploadInlineStyle(label, 'fontSize', '14px');
        setPackUploadInlineStyle(label, 'lineHeight', '1.25');
        setPackUploadInlineStyle(label, 'textAlign', 'center');
        setPackUploadInlineStyle(label, 'boxSizing', 'border-box');
      });
    };

    const scheduleMobileUploadWidth = (delay = 0) => {
      if (!isPackDrawerMode) return;
      window.setTimeout(forceMobileUploadWidth, delay);
    };

    packEditorZoom?.addEventListener('input', () => {
      invalidatePackEditorImageUpload(packEditorState.currentIndex, { clearEdit: true });
      packEditorState.zoom = Number(packEditorZoom.value || 100) / 100;
      if (packEditorZoomValue) packEditorZoomValue.textContent = `${packEditorZoom.value}%`;
      drawPackEditorCanvas();
    });

    packEditorRotation?.addEventListener('input', () => {
      invalidatePackEditorImageUpload(packEditorState.currentIndex, { clearEdit: true });
      packEditorState.rotation = Number(packEditorRotation.value || 0);
      if (packEditorRotationValue) packEditorRotationValue.textContent = `${packEditorRotation.value}°`;
      drawPackEditorCanvas();
    });

    packEditorFormatButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const format = button.dataset.packEditorFormat || 'portrait';
        invalidatePackEditorImageUpload(packEditorState.currentIndex, { clearEdit: true });
        setPackEditorFormat(format, { resize: true, draw: true });
      });
    });

    packEditorStage?.addEventListener('pointerdown', (event) => {
      if (!packEditorState.image) return;

      packEditorState.isDragging = true;
      packEditorState.dragStartX = event.clientX;
      packEditorState.dragStartY = event.clientY;
      packEditorState.dragOffsetX = packEditorState.offsetX;
      packEditorState.dragOffsetY = packEditorState.offsetY;
      packEditorStage.classList.add('is-dragging');
      packEditorStage.setPointerCapture?.(event.pointerId);
    });

    packEditorStage?.addEventListener('pointermove', (event) => {
      if (!packEditorState.isDragging) return;

      packEditorState.offsetX = packEditorState.dragOffsetX + (event.clientX - packEditorState.dragStartX);
      packEditorState.offsetY = packEditorState.dragOffsetY + (event.clientY - packEditorState.dragStartY);
      invalidatePackEditorImageUpload(packEditorState.currentIndex, { clearEdit: true });
      drawPackEditorCanvas();
    });

    const stopPackEditorDrag = (event) => {
      packEditorState.isDragging = false;
      packEditorStage?.classList.remove('is-dragging');
      if (event?.pointerId) packEditorStage?.releasePointerCapture?.(event.pointerId);
    };

    packEditorStage?.addEventListener('pointerup', stopPackEditorDrag);
    packEditorStage?.addEventListener('pointercancel', stopPackEditorDrag);
    packEditorStage?.addEventListener('pointerleave', stopPackEditorDrag);

    window.addEventListener('resize', () => {
      if (packEditor?.hidden || !packEditorState.image) return;
      resizePackEditorCanvas();
      drawPackEditorCanvas();
    });

    window.addEventListener('resize', () => {
      scheduleMobileUploadWidth(0);
      scheduleMobileDrawerMediaWrapperCompact(0, { log: true });
      scheduleMobileDrawerMediaWrapperCompact(120);
    });

    packEditorValidate?.addEventListener('click', async () => {
      if (packEditorState.completed && isCurrentPersonalizationBundle()) {
        packEditorValidate.disabled = true;
        packEditorValidate.textContent = 'Ajout au panier...';
        bundlePersonalizationConfirm?.click();
        return;
      }

      if (!packEditorState.image) return;

      const index = packEditorState.currentIndex;
      const source = packEditorState.currentSource || packEditorState.sources[index];
      const sourceSnapshot = clonePackSource(source);
      const sourceSignature = sourceSnapshot ? getPackEditorSignature([sourceSnapshot]) : '';
      const stageRect = packEditorStage?.getBoundingClientRect();
      if (!Array.isArray(packEditorState.imgbbUrls)) packEditorState.imgbbUrls = [];
      packEditorState.imgbbUrls[index] = null;

      console.info('[pack order debug] validating index/source', index + 1, summarizePackSources(sourceSnapshot ? [sourceSnapshot] : [])[0] || null);

      packEditorState.edits[index] = {
        index: index + 1,
        fileName: source?.name || `image-${index + 1}.jpg`,
        sourceSnapshot,
        sourceSignature,
        canvasPreviewDataUrl: capturePackEditorCanvasPreview(),
        format: packEditorState.format,
        zoom: packEditorState.zoom,
        rotation: packEditorState.rotation,
        offsetX: packEditorState.offsetX,
        offsetY: packEditorState.offsetY,
        canvasDisplayWidth: stageRect?.width || null,
        canvasDisplayHeight: stageRect?.height || null,
        validated: true,
        validatedAt: new Date().toISOString()
      };

      uploadPackEditedImageToImgBB(index).catch((error) => {
        console.warn('[pack imgbb] upload image échoué sans blocage validation', index + 1, error);
        if (Array.isArray(packEditorState.imgbbUrls)) packEditorState.imgbbUrls[index] = null;
      });

      const requiredImages = getRequiredPackImages();

      if (index < requiredImages - 1) {
        await loadPackEditorImage(index + 1);
        return;
      }

      packEditorState.completed = hasValidatedPackEditorEdits();

      if (packEditorState.completed) {
        if (packEditor) packEditor.classList.add('is-complete');
        if (packEditorCurrent) packEditorCurrent.textContent = `Image ${requiredImages} sur ${requiredImages}`;
        setPackEditorStatus(`Vos ${requiredImages} images sont prêtes.`);
        packEditorValidate.disabled = false;
        packEditorValidate.textContent = 'Ajouter le pack personnalisation';
      }

      updatePackPersonalizationConfirmState();
    });

    const normalizePropertyName = (name) => {
      const match = name.match(/^properties\[(.+?)\](?:\[\])?$/);
      return match ? match[1] : '';
    };

    const mergePropertyValue = (properties, key, value) => {
      if (!key || value === '') return;

      if (properties[key]) {
        properties[key] = `${properties[key]} | ${value}`;
      } else {
        properties[key] = value;
      }
    };

    const getUploadLiftProperties = () => {
      const properties = {};
      if (!bundlePersonalizationUpload) return properties;

      bundlePersonalizationUpload.querySelectorAll('input[name], textarea[name], select[name]').forEach((field) => {
        if (field.disabled || field.type === 'file' || field.type === 'submit' || field.type === 'button') return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;

        const propertyName = normalizePropertyName(field.name || '');
        if (!propertyName) return;

        const value = String(field.value || '').trim();
        mergePropertyValue(properties, propertyName, value);
      });

      return properties;
    };

    const addBundleVariantToCart = async (variantId, properties) => {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties
            }
          ]
        })
      });

      const responseText = await response.text();

      let data = null;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = null;
      }

      if (!response.ok) {
        const message =
          data?.description ||
          data?.message ||
          data?.errors ||
          responseText ||
          'Erreur inconnue Shopify';

        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
      }

      return data;
    };

    bindNativeAddToCartRefresh();
    bindBundleItemEvents();
    filterBundleItems();
    updateLoadMoreVisibility();

    if (bundleLoadMoreButton) {
      bundleLoadMoreButton.addEventListener('click', loadMoreBundleItems);
    }

    const ensurePackPersonalizationDrawerInBody = () => {
      if (!packPersonalizationDrawer || !document.body) return;
      if (packPersonalizationDrawer.parentElement !== document.body) {
        document.body.appendChild(packPersonalizationDrawer);
      }
    };

    if (bundleCta) {
      hideBundleCta();

      bundleCta.addEventListener('click', () => {
        if (!selectedBundleCard) return;

        if (readPersistentPackContext()) {
          openPersistentFullSelector();
          return;
        }

        if (!startPersistentPackFromProduct()) return;
        openBundleModal();
      });
    }

    const getMobilePackEditorUrl = () => {
      const url = new URL('/products/personnalisation-pack', window.location.origin);
      url.searchParams.set('view', 'pack');
      url.searchParams.set('drawer', '1');

      const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

      return `${url.pathname}${url.search}`;
    };

    const openPackPersonalizationDrawer = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
      }

      if (!packPersonalizationDrawer || !isPersonalizationBundle(selectedBundleCard)) return;

      try {
        sessionStorage.setItem(PACK_RETURN_STORAGE_KEY, window.location.href);
      } catch (error) {
        console.warn('[pack-editor] sauvegarde URL retour pack impossible', error);
      }

      window.location.href = getMobilePackEditorUrl();
    };

    const closePackPersonalizationDrawer = () => {
      if (!packPersonalizationDrawer) return;
      packPersonalizationDrawer.hidden = true;
      document.documentElement.classList.remove('has-pack-personalization-drawer-open');
      document.body?.classList.remove('has-pack-personalization-drawer-open');
      if (packPersonalizationDrawerIframe) {
        packPersonalizationDrawerIframe.src = 'about:blank';
      }
    };

    if (packPersonalizationDrawerOpen && packPersonalizationDrawer) {
      packPersonalizationDrawerOpen.addEventListener('click', openPackPersonalizationDrawer);
      packPersonalizationDrawerCloseButtons.forEach((button) => {
        button.addEventListener('click', closePackPersonalizationDrawer);
      });

      window.addEventListener('message', (event) => {
        if (event.origin !== window.location.origin) return;
        if (event.data?.type === 'frizi-pack-drawer-close' || event.data?.type === 'frizi-pack-close-drawer') {
          closePackPersonalizationDrawer();
          return;
        }

        if (event.data?.type === 'frizi-pack-added-to-cart') {
          closePackPersonalizationDrawer();
          window.setTimeout(() => {
            refreshMiniCartSafely().catch((error) => {
              console.error('[pack-editor] refresh mini-cart parent après ajout =', error);
            });
          }, 80);
        }
      });
    }

    if (purchaseTabs.length) {
      purchaseTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setPurchaseMode(tab.dataset.purchaseTab);
        });
      });

      setPurchaseMode('packs');
    }

    persistentPackAdd?.addEventListener('click', addCurrentPosterToPersistentPack);
    persistentPackContinue?.addEventListener('click', (event) => {
      event.preventDefault();
      resumePersistentPackComposition();
    });
    persistentPackFinalize?.addEventListener('click', async () => {
      const context = readPersistentPackContext();
      if (!context || context.selectedPosters.length !== context.requiredPosters) return;
      if (!hydratePersistentPackSelection(context)) return;

      persistentPackFinalize.disabled = true;
      try {
        await finalizeBundlePack();
      } catch (error) {
        console.error('[pack-prototype] validation du pack complet impossible', error);
        alert(error.message || "Impossible d'ajouter le pack au panier.");
        updatePersistentPackContextUI();
      }
    });
    persistentPackCancel?.addEventListener('click', () => {
      clearPersistentPackContext();
      clearBundleModalSelection();
      updatePersistentPackContextUI();
      setPurchaseMode('packs');
    });
    updatePersistentPackContextUI();

    const resumePersistentPackFromSticky = () => {
      if (!readPersistentPackContext()) return;
      openPersistentFullSelector();
    };
    window.addEventListener('frizi:pack-resume', resumePersistentPackFromSticky);

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('frizi_resume_pack') === '1' && readPersistentPackContext()) {
      currentUrl.searchParams.delete('frizi_resume_pack');
      window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
      window.requestAnimationFrame(resumePersistentPackFromSticky);
    }

    if (bundlePersonalizationUpload) {
      bindPackUploadFileInputs();
      scheduleMobileDrawerMediaWrapperCompact(0, { log: true });
      scheduleMobileDrawerMediaWrapperCompact(100);
      scheduleMobileDrawerMediaWrapperCompact(400);
      scheduleMobileUploadWidth(0);
      scheduleMobileUploadWidth(100);
      scheduleMobileUploadWidth(400);

      const packUploadObserver = new MutationObserver(() => {
        bindPackUploadFileInputs();
        scheduleMobileDrawerMediaWrapperCompact(0);
        scheduleMobileUploadWidth(0);
        if (getUploadLiftFileCount() === getRequiredPackImages()) {
          schedulePackEditorUploadSync(150);
          window.setTimeout(() => {
            syncPackEditorWithUploads().catch((error) => console.error('[pack-editor] sync post-render erreur =', error));
            scheduleMobileDrawerMediaWrapperCompact(0);
            scheduleMobileUploadWidth(0);
          }, 320);
          return;
        }

        syncPackEditorWithUploads().catch((error) => console.error('[pack-editor] sync erreur =', error));
      });

      packUploadObserver.observe(bundlePersonalizationUpload, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      setInterval(() => {
        syncPackEditorWithUploads().catch((error) => console.error('[pack-editor] sync interval erreur =', error));
      }, 800);
    }

    if (bundleCards.length) {
      bundleCards.forEach((card) => {
        card.addEventListener('click', () => {
          if (isBundleCardDisabled(card)) {
            alert(card.dataset.bundleDisabledMessage || 'Ce pack sera disponible bientôt.');
            return;
          }

          setSelectedBundle(card);

          if (isPersonalizationBundle(card)) {
            return;
          }
        });
      });
    }

    if (bundleSearch) {
      bundleSearch.addEventListener('input', async () => {
        clearBundleHasMoreCache();
        filterBundleItems();
        await updateLoadMoreVisibility();
      });
    }

    if (bundleFilters) {
      bundleFilters.addEventListener('click', async (event) => {
        const filterBtn = event.target.closest('[data-bundle-filter]');
        if (!filterBtn) return;

        await changeBundleFilter(filterBtn.dataset.bundleFilter || BEST_SELLERS_FILTER);
      });
    }

    if (bundleFiltersNext) {
      bundleFiltersNext.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        bundleFilters?.scrollBy({ left: Math.max(180, bundleFilters.clientWidth * 0.8), behavior: 'smooth' });
      });
    }

    if (bundleFiltersPrev) {
      bundleFiltersPrev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        bundleFilters?.scrollBy({ left: -Math.max(180, bundleFilters.clientWidth * 0.8), behavior: 'smooth' });
      });
    }

    if (bundleGrid) {
      bundleGrid.addEventListener('click', (event) => {
        const previewTrigger = event.target.closest('[data-bundle-preview]');
        if (!previewTrigger) return;

        event.preventDefault();
        event.stopPropagation();
        openBundlePreview(previewTrigger.closest('[data-bundle-item]'), previewTrigger);
      });
    }

    bundlePreviewCloseButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeBundlePreview();
      });
    });

    if (bundleOverlay) {
      bundleOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeBundleModal();
      });
    }

    if (bundleCloseButton) {
      bundleCloseButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeBundleModal();
      });
    }

    if (bundleModal) {
      bundleModal.addEventListener('click', (event) => {
        if (!bundleDialog) return;
        if (event.target === bundleModal) {
          closeBundleModal();
        }
      });
    }

    if (bundlePersonalizationConfirm) {
      bundlePersonalizationConfirm.addEventListener('click', async () => {
        if (!currentBundleConfig || !isCurrentPersonalizationBundle()) return;

        const uploadedCount = getUploadLiftFileCount();

        if (uploadedCount !== currentBundleConfig.qty) {
          setPersonalizationMessage(`Veuillez télécharger exactement ${currentBundleConfig.qty} images avant d'ajouter le pack.`);
          return;
        }

        if (!packEditorState.completed) {
          setPersonalizationMessage(`Veuillez valider les ${currentBundleConfig.qty} images dans l’éditeur avant d’ajouter le pack.`);
          updatePackPersonalizationConfirmState();
          return;
        }

        if (!currentBundleConfig.variantId) {
          setPersonalizationMessage('Le produit pack personnalisation Shopify n’est pas encore connecté.');
          return;
        }

        const originalText = bundlePersonalizationConfirm.textContent;
        bundlePersonalizationConfirm.disabled = true;
        bundlePersonalizationConfirm.textContent = 'Ajout au panier...';
        setPersonalizationMessage('');

        try {
          const uploadProperties = getUploadLiftProperties();

          if (!Object.keys(uploadProperties).length) {
            throw new Error(`Veuillez attendre la fin du téléchargement des ${currentBundleConfig.qty} images.`);
          }

          const properties = {
            ...uploadProperties,
            _bundle_type: currentBundleConfig.key,
            _bundle_title: currentBundleConfig.title,
            _bundle_qty: String(currentBundleConfig.qty)
          };

          try {
            const packImgBBUrls = await uploadPackEditedImagesToImgBB();
            const packProperties = buildPackImgBBProperties(packImgBBUrls);

            if (Object.keys(packProperties).length) {
              Object.assign(properties, packProperties);
              console.info('[pack cart properties]', packProperties);
            }
          } catch (imgbbError) {
            console.warn('[pack imgbb] diagnostic upload échoué sans blocage panier', imgbbError);
          }

          await addBundleVariantToCart(currentBundleConfig.variantId, properties);
          if (redirectPackFullpageAfterCart()) return;

          if (!notifyParentPackAddedToCart()) {
            await refreshMiniCartSafely();
          }
        } catch (error) {
          console.error('[bundle-personnalisation-add] erreur détaillée =', error);
          setPersonalizationMessage(error.message || "Impossible d'ajouter le pack personnalisation au panier.");
        } finally {
          bundlePersonalizationConfirm.disabled = false;
          bundlePersonalizationConfirm.textContent = originalText;
          if (packEditorValidate && isCurrentPersonalizationBundle() && packEditorState.completed) {
            packEditorValidate.disabled = false;
            packEditorValidate.textContent = 'Ajouter le pack personnalisation';
          }
        }
      });
    }

    const finalizeBundlePack = async () => {
      const selectedTitles = selectedBundleProducts.map((product) => product.title);
      const selectedHandles = selectedBundleProducts.map((product) => product.handle);
      const selectedVariantIds = selectedBundleProducts.map((product) => product.variantId);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(currentBundleConfig.variantId),
              quantity: 1,
              properties: {
                _bundle_type: currentBundleConfig.key,
                _bundle_title: currentBundleConfig.title,
                _bundle_qty: String(currentBundleConfig.qty),
                _bundle_selection: selectedTitles.join(' | '),
                _bundle_handles: selectedHandles.join('|'),
                _bundle_variant_ids: selectedVariantIds.join('|')
              }
            }
          ]
        })
      });

      const responseText = await response.text();

      let data = null;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = null;
      }

      if (!response.ok) {
        const message =
          data?.description ||
          data?.message ||
          data?.errors ||
          responseText ||
          'Erreur inconnue Shopify';

        throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
      }

      closeBundleModal({ syncPersistent: false });
      clearBundleModalSelection();
      clearPersistentPackContext();
      updatePersistentPackContextUI();
      await refreshMiniCartSafely();
    };

    if (bundleConfirm) {
      bundleConfirm.addEventListener('click', async () => {
        if (!currentBundleConfig) return;
        if (selectedBundleProducts.length !== currentBundleConfig.qty) return;

        if (!currentBundleConfig.variantId) {
          alert('Prototype pack : les affiches sont bien sélectionnées, mais le produit pack Shopify unique n’est pas encore connecté.');
          return;
        }

        bundleConfirm.disabled = true;
        const originalText = bundleConfirm.textContent;
        bundleConfirm.textContent = 'Ajout au panier...';

        try {
          await finalizeBundlePack();
        } catch (error) {
          console.error('[bundle-add] erreur détaillée =', error);
          alert(error.message || "Impossible d'ajouter le pack au panier.");
        } finally {
          bundleConfirm.disabled = false;
          bundleConfirm.textContent = originalText;
          updateBundleModalUI();
        }
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && bundlePreview && !bundlePreview.hidden) {
        event.preventDefault();
        closeBundlePreview();
        return;
      }
      if (event.key === 'Escape' && bundleModal && !bundleModal.hidden) {
        closeBundleModal();
      }
      if (event.key === 'Escape' && packPersonalizationDrawer && !packPersonalizationDrawer.hidden) {
        closePackPersonalizationDrawer();
      }
    });

    if (upsellEl) {
      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          resetFrameQty();
          setActiveFrame(button.dataset.frameOption);
        });
      });

      upsellEl.addEventListener('click', (event) => {
        const plusBtn = event.target.closest('[data-frame-plus]');
        const minusBtn = event.target.closest('[data-frame-minus]');

        if (!plusBtn && !minusBtn) return;

        const key = plusBtn?.dataset.framePlus || minusBtn?.dataset.frameMinus;
        const input = upsellEl.querySelector(`[data-frame-input="${key}"]`);
        if (!input) return;

        const current = clampQty(input.value);
        updateQty(input, plusBtn ? current + 1 : current - 1);
      });
    }

    framesOnlyButtons.forEach((framesOnlyBtn) => {
      framesOnlyBtn.addEventListener('click', async () => {
        const qty20 = clampQty(input20?.value || 0);
        const qty30 = clampQty(input30?.value || 0);

        const items = [];

        if (qty20 > 0) {
          items.push({
            id: FRAME_20_VARIANT_ID,
            quantity: qty20
          });
        }

        if (qty30 > 0) {
          items.push({
            id: FRAME_30_VARIANT_ID,
            quantity: qty30
          });
        }

        if (!items.length) {
          alert('Sélectionne au moins un cadre.');
          return;
        }

        framesOnlyButtons.forEach((btn) => {
          btn.disabled = true;
          btn.classList.add('is-loading');
        });

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          const responseText = await response.text();

          let data = null;
          try {
            data = JSON.parse(responseText);
          } catch (e) {
            data = null;
          }

          if (!response.ok) {
            const isHtmlResponse = /^\s*</.test(responseText || '');
            const message =
              data?.description ||
              data?.message ||
              data?.errors ||
              (!isHtmlResponse ? responseText : '') ||
              'Erreur inconnue Shopify';

            throw new Error(
              typeof message === 'string'
                ? message
                : "Impossible d'ajouter les cadres au panier."
            );
          }

          resetFrameQty();
          setActiveFrame('20x20');
          await refreshMiniCartSafely();
        } catch (error) {
          console.error('[frames-only] erreur détaillée =', error);
          alert(error.message || "Impossible d'ajouter les cadres au panier.");
        } finally {
          framesOnlyButtons.forEach((btn) => {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          });
        }
      });
    });

    syncStickyVisibility();
    window.addEventListener('scroll', syncStickyVisibility, { passive: true });
    window.addEventListener('resize', syncStickyVisibility);

    const initSlidingSwitch = (wrapperSelector, buttonSelector, activeClass = 'is-active') => {
      const wrappers = sectionEl.querySelectorAll(wrapperSelector);
      if (!wrappers.length) return;

      wrappers.forEach((wrapper) => {
        const buttons = wrapper.querySelectorAll(buttonSelector);
        if (!buttons.length) return;

        const updateSlider = () => {
          const activeIndex = Array.from(buttons).findIndex((btn) =>
            btn.classList.contains(activeClass)
          );

          wrapper.style.setProperty('--active-index', activeIndex > -1 ? activeIndex : 0);
        };

        updateSlider();

        buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            requestAnimationFrame(() => {
              const activeIndex = Array.from(buttons).findIndex((btn) =>
                btn.classList.contains(activeClass)
              );

              wrapper.style.setProperty('--active-index', activeIndex > -1 ? activeIndex : index);
            });
          });
        });
      });
    };

    const initPackSwitchHint = () => {
      const wrapper = sectionEl.querySelector('.purchase-mode__tabs');
      if (!wrapper || wrapper.dataset.friziPackSwitchHintBound === 'true') return;

      wrapper.dataset.friziPackSwitchHintBound = 'true';

      const simpleTab = wrapper.querySelector('[data-purchase-tab="simple"]');
      const packsTab = wrapper.querySelector('[data-purchase-tab="packs"]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const markDone = () => {
        wrapper.dataset.friziPackSwitchHintDone = 'true';
      };

      const shouldSkipHint = () => (
        wrapper.dataset.friziPackSwitchHintDone === 'true' ||
        isPackDrawerMode ||
        reduceMotion.matches
      );

      const playHint = () => {
        if (shouldSkipHint()) return;

        markDone();
        wrapper.classList.add('frizi-pack-switch-hint');
      };

      wrapper.querySelectorAll('.purchase-mode__tab').forEach((tab) => {
        tab.addEventListener('click', markDone, { once: true });
      });

      if (shouldSkipHint() || !simpleTab || !packsTab) {
        markDone();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        playHint();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry?.isIntersecting || entry.intersectionRatio < 0.45) return;

        playHint();
        observer.unobserve(wrapper);
      }, {
        threshold: [0.45]
      });

      observer.observe(wrapper);
    };

    initSlidingSwitch('.purchase-mode__tabs', '.purchase-mode__tab');
    initSlidingSwitch('.product-frame-upsell__switch', '.product-frame-upsell__switch-btn');

    setPurchaseMode('packs');
    initPackSwitchHint();

    requestAnimationFrame(() => {
      sectionEl.querySelectorAll('.purchase-mode__tabs').forEach((wrapper) => {
        const tabs = Array.from(wrapper.querySelectorAll('.purchase-mode__tab'));
        const activeIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
        wrapper.style.setProperty('--active-index', activeIndex > -1 ? activeIndex : 0);
      });
      syncPackEditorWithUploads().catch((error) => console.error('[pack-editor] sync initial erreur =', error));
    });
  };

  const initFriziProductPackSections = (scope = document) => {
    scope.querySelectorAll('[id^="shopify-section-"]').forEach(initFriziProductPack);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFriziProductPackSections());
  } else {
    initFriziProductPackSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFriziProductPack(event.target);
  });
})();
